About:
  About: About
  Contact: Contact
  HowToTrulyCareForCreators: How to truly care for creators
  HowToTrulyCareForCreatorsDec: >-
    We put creators first — no KYC, no hidden fees, no platform control. You own
    your content, your audience, and your earnings. We’re here to protect your
    freedom, not take a cut of it.
  Mission: Mission
  OURMISSIONANDVISION: OUR MISSION AND VISION
  OURMISSIONANDVISIONDec: dFans's mission is Truly caring for every creator.
  OurCreators: Our Creators
  OurMission: Our Mission, Vision and Values
  OurMissionDec: >-
    Through the adoption of blockchain and cryptocurrencies, we aim to empower
    creators worldwide to truly control their own rights, free from the
    constraints of the old world.
  OurMissionTitle: >-
    Our mission is to put creators first—empowering them with ownership,
    freedom, and fair rewards.
  OurVision: >-
    Our vision is a world where every creator can thrive without censorship,
    privacy risks, or payment limitations—enabled by blockchain and the spirit
    of decentralization.
  SAFETY: Safety
  Safety: Safety
  WHATSETSUSAPART: WHAT SETS US APART
  WHATSETSUSAPARTDec: No overbearing KYC, unlimited USDT payouts, no high fees.
  WHOWEARE: WHO WE ARE
  WHOWEAREDEC: >-
    <span class="typeface-robotoMedium">dFans is a decentralized,
    subscription-based platform built for creators, launched in 2024.</span>
    While there are many platforms in the traditional world—like OnlyFans,
    Patreon, or Buy Me a Coffee—dFans is the only one rooted entirely in the
    principles of decentralization.
  WHOWEAREDEC2: >-
    We’re not here to compete with traditional platforms. Instead, we exist as
    the other side of the same coin—working alongside them to serve creators.
    Just as fiat currency contrasts with cryptocurrency, and centralized systems
    stand opposite to decentralized networks, creators now have a choice too:
    <span class="typeface-robotoMedium">a decentralized alternative to platforms
    like OnlyFans—built to protect their right to freedom, privacy, and fair
    treatment.</span>
  WHOWEAREDEC3: >-
    Our team is globally distributed, united by a shared belief in
    decentralization. Together with the creators who believe in us, we will
    continue to defend those rights—and the future they make possible.
  WHOWEAREDEC4: Let’s build the future together.
  about: About
  dfansIsWorthATry: DFANS IS WORTH A TRY
  dfansIsWorthATryDec: >-
    Our free, open platform embraces creators of all types and cultures. Welcome
    to our shared home.
April: April
August: August
AvailableSoon: Available soon
AvailableToPayOut: Available to pay out
BlockUser:
  BlockTitle: Block user from accessing your profile.
  RestrictContent: >-
    This user will not be able to send you direct messages or respond to your
    posts.
  RestrictTip: You will not see messages or comments from this user.
  RestrictTitle: Restrict user
  Restricted: Restricted
  RestrictedTip: Chat is unavailable
  Unlocking: Unlocking User
BlockWithdrawText: You are not able to pay out as there are some disputed payments
BotLinkTips: Please do not share this link with anyone.
Brand:
  description: Logos, social icons and other templates will help you use our brand.
  description1: >-
    We love that you love dFans. We want to make it easy for you to use our
    brand in the right way. Explore this quick guide to our basic design
    elements to see how to do it.
  description2: >-
    Looking to download the dFans logo? Artwork files for print (.EPS),
    broadcast, and web (.SVG and .PNG) can be downloaded from here. For proper
    usage, refer to the Logo section in our Brand Guidelines.
  description3: >-
    Looking to represent your presence on dFans, either alone or alongside other
    social icons? It’s preferred that our logo is free of a container, but
    you’ll also find the options to use a circle, square, or square with rounded
    corners. For more details check out our Brand Guidelines.
  description4: >-
    We use the logo pairing lockups to clearly show an account on dFans. When
    pairing name and username with the dFans logo, make sure to use our logo
    once, in brand color or white, and we recommend pairing it with the name and
    username in black. Observe our clear space rules, and scale the text to 100%
    of the height of the logo. Feel free to use a typeface that’s from your
    brand’s design system. Check out our Brand Guidelines for more details.
  title: Brand <br>Resources
  title1: Brand <br>Guidelines
  title2: dFans logo
  title3: Social icons
  title4: Logo pairing
Btn:
  ADDSOCIALLINKS: ADD SOCIAL LINKS
  ADD_BENEFIT: ADD BENEFIT
  Add: Add
  AddBankAcoount: Add Bank Acoount
  AddBundle: Add Bundle
  AddImages: Add images
  AddNewPayoutWallet: Add New Payout Wallet
  AddPaidCollection: ADD PAID COLLECTION
  AddPaidCollectionTitle: Add Paid Collection
  AddPictures: Add pictures
  AddPlaylist: Add to playlist
  AddSubscriberTier: ADD SUBSCRIBER TIER
  AddSubscriberTierTitle: Add Subscriber Tier
  AddSubscriptionBundles: Add Subscription Bundles
  AddTier: ADD TIER
  AddToCategory: Add to category
  AddToCollection: Add to Collection
  AddToSubscriptionBundles: Add to Subscription Bundles
  All: All
  Apply: Apply
  ApplyNow: Apply Now!
  Audio: Audio
  Audios: Audios
  BACK: BACK
  Back: Back
  BindEmail: Bind Email
  Block: Block
  Buy: Buy
  BuyCreditCard: Buy Eth with Credit Card
  BuyEth: Buy ETH with Credit Card
  BuyFanPoints: Buy FanPoints
  BuyFirstShare: Buy Your First Share
  BuyNow: Buy Now
  BuyPoints: Buy Points
  CANCEL: CANCEL
  CLOSE: CLOSE
  CONFIRM: CONFIRM
  CONTINUEPROCESS: CONTINUE PROCESS
  COPYLINK: COPY LINK
  COPYLINKTOPROFILE: COPY LINK TO PROFILE
  CREATE_PASSWORD: CREATE PASSWORD
  CREATE_PASSWORD_TO_LOG_IN: CREATE PASSWORD TO LOG IN
  Cancel: Cancel
  CancelSubscription: Cancel Subscription
  Change: Change
  Check: Check
  CheckEligibility: Check Eligibility
  Claim: Claim
  ClaimDividends: Claim Dividends
  Claimed: Claimed
  Clear: Clear
  ClearAll: Clear all
  Close: Close
  CompactView: Compact view
  Confirm: Confirm
  ConfirmPurchase: Confirm purchase
  Connect: connect
  ConnectNow: Connect now
  ContactSupport: Contact support
  Continue: Continue
  ContinueWithEmail: CONTINUE WITH EMAIL
  Copied: Copied
  Copy: Copy
  CopyCode: Copy Code
  CopyLink: Copy Link
  CopyLinkToPost: Copy link to post
  CopyReferralCode: Copy Referral Code
  CopyReferralLink: Copy Referral Link
  Create: Create
  CreateCollection: Create Collection
  CreateNewCategory: Create new category
  CreateSubscriptionTiers: Create Subscription Tiers
  Crypto: Crypto
  DISMISS: DISMISS
  DONE: DONE
  Delete: Delete
  DeleteCategory: Delete Category
  DeleteLabel: Delete label
  DeletePost: Delete post
  DeleteTier: Delete tier
  DeleteWallet: Delete wallet
  Deposit USDT: Deposit USDT
  DepositSuccessful: Deposit Successful
  Details: Details
  DisableFilter: Disable Filter
  Dismiss: DISMISS
  Done: Done
  DontShow: Don’t show this again
  Download: |
    Download
  EDIT: EDIT
  EXIT: EXIT
  EarnCashBack: Earn 1.5% lifetime cashback
  EarnPoints: Earn Points
  Edit: Edit
  EditAccount: Edit account
  EditNotes: Edit notes
  EditPost: Edit post
  EditProfile: Edit profile
  EditWelcomeMsg: Edit my welcome message
  EnableTierHighlighting: Enable tier highlighting
  EthereumBridge: Ethereum Bridge to Arbitrum
  Expired: Expired
  Filters: Filters
  FindMore: Find more
  Followers: Followers
  ForgotPassword: Forgot password?
  Free: Free
  FullView: Full view
  Gallery: Gallery
  GetCode: Get code
  GoBackTo: Go back to dFans.xyz
  GoToPost: Go to Post
  IAgree: i agree
  Image: Image
  LOG_IN: LOG IN
  LetsGetStarted: Let’s Get Started!
  Like: Like
  LoadMore: Load more
  LogINAsDifferentUser: Log in as different user
  LogIn: Log in
  LogInToViewPost: Log in to view post
  Logout: Logout
  MAX: MAX
  Max: Max
  Message: Message
  Modify: Modify
  More: More
  NEW_MESSAGE: NEW MESSAGE
  NEXT: NEXT
  NewCategory: New Category
  NewLabel: New Label
  Next: Next
  'No': 'No'
  NoFPClaim: No FP to claim
  OK: OK
  OpenInBrowser: Open In Chrome
  Paid: Paid
  Pay: Pay
  PayNow: Pay now
  PayWith: Pay with
  PaymentProcessing: Payment processing
  Photo: Photo
  Photos: Photos
  PinnedPost: Pinned post
  Play: Play
  PointHistory: Point History
  Preview: Preview
  Primary: Primary
  Proceed: Proceed
  Quit: Quit
  ReadLess: Read less
  ReadMore: Read More
  ReadMoreEtc: Read more...
  Remove: Remove
  RemoveSelectedMedia: Delete selected media
  RenameLabel: Rename label
  RenameUser: Rename user
  Reply: Reply
  Report: Report
  Restrict: Restrict
  Retry: Retry
  RewardsDividends: Rewards Dividends
  SAVE: SAVE
  SAVEFORLATER: SAVE FOR LATER
  SEE_ALL: SEE ALL
  SEND: SEND
  SEND_CONFIRMATION: SEND CONFIRMATION
  SIGN_IN_WITH_EMAIL: Log in with Email
  SIGN_UP: SIGN UP
  STARTPROMOTIONGAMPAIGN: START PROMOTION GAMPAIGN
  STOPPROMOTION: STOP PROMOTION
  Save: Save
  SaveCapital: Save
  SaveCard: Save card
  Search: Search
  SeeAll: See all
  SelectAll: Select all
  SelectImage: Select image
  Selected: selected
  Send: Send
  SendATip: Send a tip
  SendCode: Send code
  SendEtc: Send...
  SendNow: Send now
  SendToAll: Send to All
  SetAsPrimary: Set as primary
  SetUpSubscription: Set up your subscription now
  Share: Share
  ShareDepositDetail: Share Deposit Detail
  ShareToTelegram: Share to Telegram
  ShowMore: show more
  SignUpAsAFan: Sign up as a Fan
  SignWithGoogle: Log in with Google
  SignWithTwitter: Log in with X
  Skip: Skip
  Sort: Sort
  StakeDFS: Stake Share
  StakeShares: Stake Shares
  StakingTransactions: Staking Transactions
  StartCampaign: Start Campaign
  Submit: Submit
  Submitted: Submitted
  Subscribers: Subscribers
  Suspended: Suspended
  TakeMeHome: Take me home
  Texts: Texts
  TopUpNow: Top-Up Now
  TopUpWithCreditCard: Top Up with Credit Card
  TryTraceless: Try traceless top-up
  UNLOCKPRICE: PPV POST – BUY TO VIEW
  UNLOCK_FOR: UNLOCK FOR
  UPDATE_EMAIL_ADDRESS: UPDATE EMAIL ADDRESS
  Unlike: Unlike
  UnlockByCollection: PRIVATE COLLECTION - BUY TO ACCESS
  UnlockBySubscribe: ' SUBSCRIBE TO SEE USER''S POSTS '
  UnlockNow: Unlock Now
  Unlocked: Unlocked
  Unread: Unread
  Unsend: Unsend
  Unsent: Unsent
  Unsubscribe: Unsubscribe
  UploadFiles: Upload files
  VERIFY_EMAIL: VERIFY EMAIL
  VIEW_MESSAGES: VIEW MESSAGES
  Video: Video
  VideoGuide: Creators' video guide
  Videos: Videos
  ViewAll: View all
  ViewCollection: View Collection
  ViewOnBlockchainExplorer: View on blockchain explorer
  ViewReferralRewards: View Referral Rewards
  ViewTransaction: View Transaction
  Withdraw: Withdraw
  YES_UNSEND: YES, UNSEND
  'Yes': 'Yes'
  YesDelete: Yes, delete
  YesEnable: Yes, Enable!
  disagree: disagree
  hasEditProfile: Describe your page
  hasPublishPost: Make your first public post
  hasPublishSubscription: Create your subscription
  processing: processing
  selfie: selfie
  unBlock: Unblock
  unRestrict: Unrestrict
  upload: upload
  viewLess: View less
  viewMore: View more
CheckSuccess: Check success
CheckUpdates: You can check back later for updates.
ClearAll: Clear all
Clicks: Clicks
ClicksCount: Clicks count
Close: Close
Comment:
  AddComment: Add a comment...
  Delete: Delete
  Reply: Reply
  ViewMore: View more comments
ConfirmEmail: Confirm email address to proceed security check
Contact:
  CancelMyPayoutRequest: Cancel my payout request
  CreatorSuggestionsAndFeedback: Creator Suggestions and Feedback
  CreditCardPayments: Credit Card Payments
  LawEnforcementLegalMatter: Law Enforcement/ Legal Matter
  Other: Other
  Payouts: Payouts
  ProfileAccess: Profile Access
  RegistrationAndVerification: Registration and Verification
  ReportIllegalMaterialOrBehavior: Report Illegal Material or Behavior
  ReportingStolenContent: Reporting Stolen Content
  TechnicalQuestions: Technical Questions
ContactSupport: CONTACT SUPPORT
CopyLink: COPY LINK
Copywriting:
  80-20Split: >-
    You’ll receive 80% of your earnings by default, but once your monthly
    revenue hits a milestone, bonus commissions can boost your earnings up to
    85%!
  AddCommentPost: >-
    Add a comment to a post can boost your engagement with your favorite star.
    You can complete the task by
  AddCommentPostNow: and add a comment to a post now.
  AddLinks: Add links to your social media profiles
  AddingDetails: >-
    Adding some details helps visitors learn more about you and what you plan to
    share here.
  AgreeToOur: By signing up you agree to our
  AlreadyHaveAnAccount: Already have an account?
  AnnounceAudit: >-
    We\'re thrilled to announce that we\'ve passed the audit by {'@'}Beosincom,
    a highly trusted audit team in the industry!Their rigorous process reaffirms
    the robustness and integrity of our platform.Our smart contracts are secure
    and we adamantly reject any form of scam.A huge thanks to Beosin for their
    excellent work!Stay safe and continue to trust us for your needs.
  ApplicationBeApproved: Your application has been approved! Congratulations on joining dFans.
  ApplicationBeReceived: >-
    We will review your application soon. If you do not receive the confirmation
    message within 8 hours, <span class="text-darkBrandYellow
    dark:text-brandYellow">please check your “junk mail”</span> folder <span
    class="text-darkBrandYellow dark:text-brandYellow">or “spam”</span> folder.
  ApplicationNotBeApproved: Your dFans creator account application has not been approved!
  ApplicationSubbmit: Your application has been submitted
  ApplyVerifiedCreator: Apply and be a Verified creator within a few minutes!
  BridgeETH: Bridge your ETH to Arbitrum to receive this release.
  ChangeEmailTip: In order to change email you need to have access to your current email.
  ChangeUsernameText1: Username can only be changed once a year.
  ChangeUsernameText2: Last changed on
  CheckForConfirmationEmail: Please check your inbox for the confirmation email.
  CheckWallet: has been completed! Please check your wallet!
  CheckYourEmail: >-
    Please check your e-mail for a temporary password reset link and make sure
    you set a new one right after you click it.
  ChooseChain: E.g. Ethereum, BNB Chain or Polygon, etc.
  ChooseHighlightTier: >-
    One tier will be displayed more prominently on your page to promote it.
    Choose how your highlighted tier should be selected.
  ChooseSubject: Please choose Subjecct
  ClaimRewards: >-
    The daily staking rewards for each user can be calculated using the
    following formula
  ClaimSchedule: >-
    The claimed staking dividends will be deposited into your wallet within 24
    hours
  CollectionPrice: Your collection's price is set at
  CommissionCashback: >-
    Just $1! <br> dFans offers free fiat-to-USDT conversion, reducing creators’
    withdrawal costs!
  ConfirmCollectionPurchase: Confirm Collection Purchase
  ConfirmMessagePurchase: Confirm Message Purchase
  ConfirmOver18: and confirm that you are at least 18 years old.
  ConfirmSinglePostPurchase: Confirm Single Post Purchase
  ConfirmSubscriptionPurchase: Confirm Subscription Purchase
  ConfirmTips: Confirm Tips
  ContactCustomer: If you have any questions, contact our customer service on Telegram
  CreateSocialStatus: >-
    Everyone have a Social Status Can Be Valued. Create Your Social Status on
    dFans. The initial value of your social status is zero. Social Status
    Corresponds to Shares, Value Determined by Shareholding. When fans buy
    shares, your social status rises. When fans sell shares, your social status
    fallsial status falls
  CreationPlanRule: Please select you plan creating
  CreditCardBuys: Earn more money, more securely
  CryptocurrencySafe: >-
    We’ve got you covered! Since Europe restricts USDT payments, dFans offers
    USDC settlements for European creators, ensuring you receive your earnings
    seamlessly.
  DFSBeDistributed2: '{Number} Shares will be distributed to dFans staking pool from your account.'
  DFansCampaigns: >-
    Keeping track of exactly where and how you’ve gained new subscribers might
    sound like an overwhelming task. But knowing which of your promotional
    efforts generated the most clicks and subscriptions to your dFans profile
    can be crucial to your success. Fortunately, the dFans Campaign feature
    makes it easy to keep tabs on this important data.
  DFansCampaignsExplained1: >-
    In a few easy steps, you can generate unique tracking links to your dFans
    profile. By using those links, you can track where your profile clicks are
    coming from and how many visitors become subscribers.
  DFansCampaignsExplained2: >-
    For example, you can create a unique tracking link just to measure how many
    profile visits (and subscribers) you’ve gotten from your Twitter bio alone.
    Or your Linktree. Or your blog, personal website, promotional discount, or
    anywhere else.
  DFansIntroduction: >-
    dFans is a crypto-driven platform offering a free space for direct
    connections between you and your fans. You have the opportunity to earn
    cryptocurrency, enjoy the thrill of its appreciation, and face no withdrawal
    restrictions.
  DFansOnlySupportETHTransactions: dFans only support ETH transactions on
  DailyDividendAmount: '{ratio}% of the net profit will be allocated to dFans shareholders.'
  DeleteAIPhoto: Are you sure you want to delete this paid photo?
  DeleteCollection: Are you sure you want to delete this collection?
  DeleteLabel: Are you sure you want to delete {labelName}?
  DeletePost: Delete Post?
  DeleteTier: Delete this tier?
  DeleteTierDescs: Are you sure you want to delete this tier?
  DeleteTierDescs1: This cannot be undone.
  DepositETH: Deposit ETH in your dFans wallet
  DeterFans: which may deter fans. Confirm release?
  DiscoverLatest: Discover the latest interesting things shared by collector
  DistributedBonus: >-
    50% of the bonus will be distributed equally to each buyer of the week, and
    the remaining 50% will be distributed to the last buyer of the week (based
    on the natural week time)
  DividendContract: This is a dividend contract.
  DomainNameRule: Domain name already exists!
  ETHLoadingDec: >-
    This process requires network confirmations. You can now view creator's
    content before crediting your payment
  EaringsAvailable: Earnings Available to Withdraw
  'EarnMorePoints ': Earn more points and enjoy token airdrops
  EmailCorrectRule: Please input the correct email address
  EmailIsVerified: '{email} is verified'
  EmailIsVerified2: E-mail {email} is verified
  EmailRule: Please enter Email
  EnterDashboard: Enter the creator's dashboard
  EnterFirstNameRule: Please enter First name
  EnterMessage: Please enter Message
  EnterSubject: Please enter Subject
  EnterUserNameRule: Please enter user name
  EstablishSocialStatus: Establish Your Initial Social Status
  ExpectWhat: Let your members know what they can expect from this membership tier
  FAQ10: >-
    It only takes a few minutes—or even less. Joining dFans is incredibly fast
    since there is no ID verification process.
  FAQ6: >-
    We don’t need to explain—just look at the facts. The U.S. has already
    recognized cryptocurrency as a strategic reserve and is actively advancing
    crypto payment reforms alongside fiat. Let’s embrace the future together and
    watch the world evolve! 🚀
  FAQ7: >-
    dFans is a decentralized subscription-based social platform where creators
    can share, earn, and connect with their fans effortlessly. Enjoy the fastest
    payouts and true creative freedom—built for the future.
  FAQ8: >-
    dFans embraces all creators—whether you’re an influencer, an adult creator,
    an athlete, an artist, an AI creator, or beyond. As a decentralized
    platform, we stand for freedom and openness. Here, you can create without
    limits or overbearing censorship.
  FAQ9: >-
    dFans conducts KYC verification during the creator onboarding process,
    specifically for certain content categories. This verification does not
    affect a creator’s ability to join the platform — it is in place solely to
    support compliance and ensure a safe, trustworthy environment for both
    creators and users.
  FanPoints: FanPoints can be used to unlock crypto collections.
  FirstCollector: Be the first collector for this collection
  FollowFrens: >-
    Follow a few frens to get some posts up in this feed. Start by following top
    creators and collectors.
  FollowersSubscribers: >-
    dFans offers the most revenue streams in the industry! Earn from
    subscriptions, exclusive collections, pay-to-view posts, and real-time paid
    chats—maximize your earnings!
  FollowvideoGuides: Follow the videoGuides in this link to begin posting and earning
  FreeOpen: >-
    Quick setup, post freely. We won't easily restrict your freedom or
    arbitrarily censor your content.
  GenesisNFTHolders: Genesis NFT holders.
  GoToTreding: Go to Treding
  GoneIncognito: You've gone Incognito
  GrtRewards: >-
    You will get some exclusive rewards when purchase NFT Pass. You can complete
    the task by
  HavePoints: ' You currently have insufficient points.'
  HaveSubscribed: You have subscribed to
  HowFrequent: >-
    We understand that some creators prefer USD withdrawals. We’re working with
    partners to offer this option, but bank transfer fees will apply, charged by
    third-party payment providers and banks.
  HowMuchMoney: >-
    As a creator, you can earn up to 85% of everything you sell on the
    site—starting at 80%, with an extra 5% rewarded based on your monthly
    revenue!
  InvestBenefits: SUBSCRIPTION BENEFITS
  InviteCreatorsText1: Any dFans creators who join using "your link"
  InviteCreatorsText2: You will receive a 5% cashback on their earnings on dFans for the first year
  InviteCreatorsText3: If you invite more than 10 creators, the 5% cashback becomes permanent
  InviteFansText1: Any fans who sign up for dFans using "your link"
  InviteFansText2: >-
    You will permanently receive 1.5% of their spending amount on the dFans
    platform
  InviteeCanBeInvitationCode: Invitees can become creators using an invitation code.
  InviteeCanOpenLink: The invitee can open the link to login dFans.xyz.
  LettersRule: Please enter uppercase or lowercase letters
  LongPress: Long press to identify the QR code in the picture
  MatchTraders: >-
    We will match you with traders who can provide ETH, which usually takes
    15-30 minutes to complete the transaction.
  MyVeDFS: >-
    When your staking is successful, veShare, a tokenized representation of your
    staked Share will be distributed to your account. veShare will be used to
    calculate the daily dividends that you can earn from platform net profits.
  NFTBeenSent: >-
    Your creator application has been approved. Set up your personal page
    immediately!
  NFTSaleBeShared: of NFT sale will be shared
  NFTSaleWillBeShared: |-
    of NFT sale will be shared with
                  Genesis NFT holders.
  NameLengthRule: The name must be between 4 and 50 characters long.
  NoUnreadMessages: No Unread Messages
  NoeOneKnowYou: No one will know who you are.
  NotFound: We can’t find the page that you’re looking for. Probably the link is broken.
  NotFoundCriteria: We couldn't find anything with this criteria
  NotPaidYet: ' ${price} not paid yet ,'
  NothingFoundFor: Nothing found for
  NumberStartRule: Domain name cannot start with a number
  OldPasswordsCannotBeReused: Old passwords cannot be reused
  PageReady: Your dFans Page is ready!
  PageURL: Here's your Page URL
  PaidYet: ${price} paid already ,
  PassedAudit: We\'ve passed the audit by Beosin, Our smart contracts are secure...
  PayWithALiPay: Pay with Alipay
  PayWithCreditCard: Pay with credit card
  PaymentProcessing: Your payment is processing on the blockchain. Please wait for a few seconds.
  PlatformBuybacks: >-
    dFans periodically conducts buybacks of DFS tokens from the market based on
    the company’s net profits. The platform opens targeted buyback windows for
    shareholders on dFans, allowing them to cash out their holdings at any time.
  PleaseAddYourWalletAddress: Please add your wallet address
  PleaseCheckNewYourEmail: >-
    Please check your new email {email} for a confirmation code and enter it
    below. Code will be valid for
  PleaseCheckYourEmail: "Please check your email\_{email}\_for a confirmation code and enter it below. Code will be valid for"
  PleaseEnterYourEmail: >-
    Please enter your new E-mail address. Due to security reasons form will be
    valid for
  PleaseSelectRecepient: Please select recepient
  PleaseSelectUsersToSend: Please select users to send them a message
  PlusGasFees: ETH (plus gas fees) on Arbitrum.
  PostAnyContent: >-
    Payout speed depends on the payment method used by fans:

    <div> · If fans pay with USDT, ETH, or SOL, or use a credit card to buy
    crypto, dFans settles your earnings immediately after payment, typically
    within 24 hours. </div>

    <div> · If fans pay in fiat via credit card, dFans must wait for third-party
    payment processing, which can take several days.</div>
  PotentialMembers: Potential members will see that you recommend this tier
  PriceInfo: dFans is priced in USD.
  PurchaseNFT: and purchase NFT Pass to unlock post.
  PurchaseNFTPass: and purchase NFT Pass.
  PurchaseRequest: Your purchase request for
  Quiet: It's a bit quiet in here
  QuoteUpdates: Quote updates in 8s
  ReceiveUSDTPaymentSettlements: It is also used to receive USDT payment settlements.
  ReferralBonuses: >-
    Talk Like a Human. Sell Like a Pro.Helps you craft better replies, chat
    faster, save time — and boost your earnings.
  ReferralBonusesDec: >-
    Say goodbye to managing and training unreliable chatters – and say hello to
    a smarter way to grow your business.
  ReferralEarn: per referral + Earn an extra 50% of their NFT purchase points.
  ReferralsEarnings: Invite creators to join and earn a share once they start earning
  RegionRule: Please select a country
  ResendInSeconds: Resend in
  RestoreAccess: >-
    If you have an dFans account, you will receive a password reset link to this
    e-mail.
  RestoreAccess2: >-
    Please enter the email you used to register your dFans account and we will
    send an email to restore your account.
  RetainNote: 'Note: We''ll retain some ETH in your wallet for collection gas fees.'
  RewardPercentIntro: >-
    When a user you refer signs up for dFans using your invitation link and
    becomes a creator, you'll earn a share equivalent to 5% of their earnings.
  RewardRulesText1: >-
    Rewards earned from invitations will be settled daily and automatically paid
    out to your dFans wallet. You can view all details on the "Statistics" page.
  RewardRulesText2: >-
    If a fan's purchase is made using a credit card in USD, after deducting bank
    fees, the platform will pay you in USDT to your wallet, which you can
    manually withdraw.
  RewardRulesText3: >-
    If a fan's purchase is made using a credit card in USD, after deducting bank
    fees, the platform will pay you in USDT to your wallet, which you can
    manually withdraw.
  RewardRulesText4: >-
    Rewards earned from invitations will be settled daily and automatically paid
    out to your dFans wallet. You can view all details on the "Statistics" page.
  RewardWithCreditCard: Tip with credit card
  ScanOrUseWallet: Scan this QR code or use wallet address to top up.
  ScanQRCode: Long press to identify the QR code
  SecondConfirmCheck1: >-
    I understand that during the locked period, I am not able to transfer nor
    sell the locked DFS, and I will not be entitled to DFS staking rewards from
    the locked DFS.
  SecondConfirmCheck2: >-
    I understand that when I trade/transfer DFS to another person, the other
    person has the right to stake the DFS.
  SecondConfirmCheck3: >-
    I understand that once I stake my Shares, I will not be able to transfer,
    trade, nor redeem the staked Shares. If I want to get it back, I will need
    to submit a redeem request and wait for the redemption quota to be open.
  SecondConfirmCheck4: >-
    I understand that when I trade/transfer Shares to another person, the other
    person has the right to stake the Shares.
  SecondConfirmCheck5: >-
    I have read and agreed to the <span style="color: #FCD535">dFans Share
    Staking Agreement</span>
  SecondConfirmation: >-
    Please confirm that you have read the below information, that you understand
    what you have read, and that you accept the following terms:
  SelectAnyConversation: Select any Conversation or send a New Message
  SelectAnyConversation2: Select any Conversation to send a New Message
  SellDigitalProductsDesc: >-
    dFans offers a lucrative "Invite Cashback" policy to help creators achieve
    greater financial returns.
  SellDigitalProductsDesc1: >-
    1.5%: If you invite fans to make purchases, you'll permanently earn 1.5%
    cashback on their spending, no matter the amount.
  SellDigitalProductsDesc2: >-
    5%: If you invite other creators to join, you'll directly receive 5% of
    their earnings as a continuous reward.
  SetEmailTip: Please verify your email address
  SetPasswordTip: >-
    We recommend creating a password for your email login account to use for
    future logins.
  SettingUpYourNewCampaign1: >-
    1. Log in to your dFans account and access your <span class="profileSettings
    font-bg cursor-pointer">Profile Settings</span>.
  SettingUpYourNewCampaign2: >-
    2. Scroll to the bottom, and select ‘<span  class="trackingLinks font-bg
    cursor-pointer">Tracking links</span>’ under the Subscription header.
  SettingUpYourNewCampaign3: 3. Click the ‘Create New Tracking Link’ button.
  SettingUpYourNewCampaign4: 4. Assign a name for your tracking link.
  SettingUpYourNewCampaign4-1: >-
    To stay organized, we suggest giving your tracking link a name based on how
    or where you plan to use it.
  SettingUpYourNewCampaign4-2: For example, “Linktree bio”, “Twitter”, or “Paid promotions”.
  SettingUpYourNewCampaign5: 5. Click ‘Create Tracking Link’.
  SettingUpYourNewCampaign6: 6. Copy the link and share it!
  SettingUpYourNewCampaign6-1: You’ll find your new campaign’s tracking link under ‘Recent’.
  SettingUpYourNewCampaign6-2: >-
    Here’s also where you can keep tabs on how many clicks your individual
    Campaign links have generated, and how many of those clicks turned into
    subscriptions.
  ShareDividendsTitle: How many dividends can I earn from staking?
  SharesBeDistributed: '{number} Shares will be distributed to your account after the claim period.'
  StakeShareWarn: >-
    When staking a Share, you will earn daily dividends from platform daily
    profits.
  StakingRewards: >-
    The staking rewards depend on the platform's daily earnings and are
    distributed proportionally based on the amount of Shares staked by users.
  StakingRules: >-
    When your staking is successful, veShare, a tokenized representation of your
    staked Shares will be distributed to your account. The StakingRules amount
    you receive is calculated based on the amount of Shares that you staked.
  StakingSharesRewards: >-
    Staking Share rewards per user = Total reward Shares for the day * User's
    current veShare amount / Sum of all veShare in the market for the day
  StakingYields: >-
    dFans calculates the daily net profits and distributes them to shareholders
    according to market prices and dividend rules. Shareholders can immediately
    sell their Share to cash in on profits, or continue to hold and stake them,
    sharing in the platform’s potential rapid value growth for greater returns.
  SubscribeCreditCard: Subscribe with Credit Card
  SubscribeProfile: subscribed to your
  SubscriptionPaymentFailed: >-
    Subscription payment failed! Please top up your wallet to avoid your
    subscription being cancelled.
  SuccessSubscription: Successful subscription!
  SufficientFundsTxt: You don’t have sufficient funds to proceed with this purchase.
  SupportSuccess: Support successfully!
  SureDelete: Are you sure you want to delete this post?
  SureDeleteAccount: Are your sure?
  SureDeleteAccountDec: >-
    Once deleted, your account will not be able to be restored and you will have
    to create a new one.
  SureDeleteCard: Are your sure delete this card?
  SureDeletePayoutWallet: Are your sure delete this payout wallet?
  SwitchNetwork: Please switch to the appropriate network.
  ThanksForApplying: Thanks for applying for access.
  TopUp: You can even top up without leaving a trace.
  TotalRewardDFS: >-
    Total reward Shares = (Platform daily revenue - Creator income - Referral
    fee - Platform operating costs) / Shares market price on the day
  TotalRewardShares: >-
    Total reward Shares = (Platform daily revenue - Creator income - Referral
    fee - Platform operating costs) / Shares market price on the day
  TransactionCantMatched: >-
    Once the transaction cannot be fully matched, we will refund the money on
    the same day.
  TransactionMatched: >-
    Once the transaction matched, this amount of ETH coins will be transferred
    to your account within 15-30 minutes.
  TransactionProcessing: >-
    Your transaction is processing now. It will be taking a few seconds for the
    Ethereum network to complete. Meanwhile, this transaction will cost you a
    small amount of ETH to cover the network fee. We do not profit this fee. You
    can close this window and check the transaction status from the payments
    history.
  UndoAction: You cannot undo this action.
  UndoActionSimple: You cannot undo this action.
  UnlockedPremiu: View unlocked premium content
  Username: Please enter Username
  VerificationCodeTip: >-
    We have sent the verification code to your login email {email}, please check
    it in time.
  VerifiedCreator: Congratulations! You're now a verified dFans creator.
  WHY_DECENTRALIZE: >-
    The decentralized mechanism ensures that every creator on the dFans platform
    can hold shares and enjoy shareholder benefits. Without altering the
    creators’ revenue share (80%), dFans allows creators to become shareholders
    and distributes the platform’s net profits as dividends to its shareholders
    daily.
  WeeklyRevenue: >-
    30% of the weekly revenue from the Creator Collection goes into the prize
    pool and is obtained by the purchaser;
  WelcomeToDFans: Welcome to dFans as a Creator !
  WhatIsDFS: >-
    DFS is the platform token that dFans plans to launch, existing as an ERC-20
    token on the Ethereum blockchain, and is used to value dFans shares. As
    such, there is a conversion relationship between DFS and shares. When
    shareholders sell their shares, the corresponding DFS tokens on the
    blockchain trading market will also be sold, enabling shareholders to gain
    profits. Currently, DFS has not yet been issued on any exchange, so
    shareholders are temporarily unable to trade, but this does not affect the
    acquisition and staking of shares within the dFans platform.
  WhatIsDFS1: >-
    The dFans team is discussing the timeline for the token issuance, so please
    keep an eye on official announcements on the website.
  WhatIsShare: >-
    Share serves as the parent company's stock for dFans, a decentralized social
    platform that opens up its company shares entirely, no longer monopolizing
    stock income. Depending on the contributions creators bring to the platform,
    in addition to their earnings, they are incentivized with company shares.
    Beyond transaction and referral incentives, dFans distributes daily net
    profits in the form of shares to creators (see distribution rules for
    details). The price of shares is market-determined, with a total issuance of
    2 billion shares. Over 58% of these are held by platform contributors
    (creators, fans, etc.), gradually introduced to the market under specific
    rules, while the remaining 42% are held by the dFans team and investors.
  WhatPaymentMethods: >-
    If fans pay by credit card, dFans provides USDT withdrawals—free conversion
    to USDT with just a $1 withdrawal fee, saving creators from high bank
    transfer fees! If fans pay directly in ETH or SOL, creators can withdraw in
    the same currency!
  WhyDecentralizeIntro: >-
    The decentralized mechanism ensures that every creator on the dFans platform
    can hold shares and enjoy shareholder benefits. Without altering the
    creators’ revenue share (80%), dFans allows creators to become shareholders
    and distributes the platform’s net profits as dividends to its shareholders
    daily.
  WrongCode: Wrong code
  WrongCurrentPassword: Wrong current password.
  WrongPasswordTip: >-
    Visit <span class="underline text-white text-op-100">Help Center</span> for
    additional help if you are unable to log in with your existing dFans Account
  YouAreAllCaughtUp: You're all caught up
  YouCanBridgeETH: >-
    You can bridge ETH from Ethereum to Arbitrum through dFans. Please contact
    our support team
  YouNeed: You need at least
  YourMediaLoading: Your media is currently loading
  YourMediaProcessing: Your media is currently processing
  YourOwnEarnings: Start earning as a creator and pay out
  loginDec1: A Decentralized Subscription Platform
  loginDec2: Empowering You to Support Creators Safely
  promotionDec: >-
    Offer a free trial or a discounted subscription on your profile for a
    limited number of new or already expired subscribers.
CreateLinksForCampaigns: Create and share separate links for your campaigns.
CreateTrackingLink: CREATE NEW TRACKING LINK
CreateTrackingLinkLower: Create tracking link
CurrencyBalance: '{currency} Balance'
DELETE: DELETE
December: December
DestinationETH: Destination {currency} wallet address
DestinationUSDT: Destination USDT wallet address
Dispute: Dispute
DisputeDate: Dispute date
DisputeDesc: >-
  Our payment processor has informed that <strong>the cardholder claims they did
  not authorize the purchase.</strong> The payment is currently on hold and will
  be returned to you if the issuing bank resolves the issue in your favor, or
  returned to the cardholder if the decision is in their favor.
DisputeDesc2: >-
  Our payment processor has identified potential risks with this transaction.
  Payments will be held for at least <strong>15 days</strong> for a thorough
  review to ensure no risk is present.
DisputeDetails: DISPUTE DETAILS
DisputeRefundDesc: This payment was refunded by the payment processor due to the risk evaluation.
DisputeTime: Dispute Time
Earnings: Earnings
EmailVerification: Please request a verification code via email.
EndDate: End Date
EnterOtherResource: Please enter other resource
EnterTrackingLinkName: Please enter the tracking link name
EthBalance: ETH Balance
EthPayments: ETH Payments
FAQ:
  CommunityGuidelines: Community Guidelines
  HelpCenter: Help Center
  Hi: Hi
  HowCanWeHelp: how can we help?
  'No': 'No'
  SearchResultsFor: Search results for
  ThankYouForProvidingFeedback: Thank you for providing feedback!
  WasThisHelpful: Was this helpful?
  'Yes': 'Yes'
February: February
FollowedOn: Followed on
Footer:
  AboutDFans: About dFans
  AppealsPolicy: Appeals Policy
  Blog: Blog
  Branding: Branding
  ComplaintsPolicy: Complaints Policy
  ContentProviderAgreement: Content Provider Agreement
  CookieNotice: Cookie Notice
  Help: Help
  KYCPolicy: KYC Policy
  Partner: Partner
  PressRelease: Press Release
  Privacy: Privacy
  StandardContractBetweenFanAndCreator: Standard Contract between Fan and Creator
  TermOfService: Term of Service
  VideoGuide: Video Guide
  Whitepaper: Whitepaper
  dFansSafetyTransparencyCenter: dFans Safety & Transparency Center
GasFee: Gas fee
GetBotLink: Get bot link
Glabel: {}
Global:
  ' GetSomeETHOnArbitrum': ' Get some ETH on Arbitrum'
  ' GetSomeETHOnArbitrumDec': ' You’ll use ETH, the official currency of Arbitrum, when you support your favorite creators.'
  ' WalletBalance': ' Wallet Balance'
  24hVolume: 24h volume
  30-DayDividends: 30-Day Dividends
  ADDTOQUEUE: ADD TO QUEUE
  AIChats: AI Chats
  ALL: All
  AMOUNT: AMOUNT
  AMOUNTPAID: AMOUNT PAID
  AMOUNT_OF_EARNING: AMOUNT OF EARNING
  AMOUNT_OF_INCOME: AMOUNT OF INCOME
  AMOUNT_OF_INVESTMENT: AMOUNT OF INVESTMENT
  AVAILABLE_TO_WITHDRAW: AVAILABLE TO WITHDRAW
  Account: Account
  AccountInfo: Account info
  AccountManagement: Account management
  Activated: Activated
  ActivationDate: Activation Date
  Active: Active
  ActiveDrops: Active Drops
  ActiveSubscription: Your subscriber
  ActiveSubscriptionDesc1: Your current subscription plan remains active until
  ActiveSubscriptionDesc2: >-
    If you decide to switch to the new subscription plan, you will be charged
    for it on
  Add: Add
  AddAPaymentCard: Add A Payment Card
  AddBankAccount: Add bank account
  AddBenefit: Add Benefit
  AddCover: Add cover
  AddLabels: Add labels
  AddMediaFromVault: Add media from vault
  AddNewCard: Add new card
  AddNotes: Add notes
  AddPaymentCard: Add Payment Card
  AddToANewMessage: Add to a new message
  AddToANewPost: Add to a new post
  AddToCategoryTip: Please add a category
  AddToHomeScreen: Add to Home Screen
  AddToSubscriptionPlan: Add to Subscription Plan
  Address: Address
  AddressLine: Address line
  AiChatbotSetting: AI chatbot setting
  AlipayEarningsWithdrawal: Alipay Earnings Withdrawal
  AlipayPayments: Alipay Payments
  AllMedias: All media
  AllPosts: All posts
  AllRightsReserved: All Rights Reserved
  AllTime: All time
  AllowOthersToFindMeByName: Allow others to find me by name
  Amount: Amount
  AmountCharged: Amount charged
  AmountCompounded: Amount (compounded)
  And: and
  ApplicationApproved: Creator Account Approved!
  ApplyBecomeCreator: Apply to become a creator
  ApplyDesc: >-
    The fiat payment channel is operated by a third-party provider. Applicants
    are required to complete identity verification, which will be submitted
    directly to the provider. dFans does not collect or store this information.
  ApplySoon: Application received. Activation coming soon.
  ApproveRequest: Are you sure you want to approve this request?
  Approved: Approved
  Approximately: approximately
  Arbitrum: Arbitrum
  Around: around
  ArrivalTime: Arrival time
  Ascending: Ascending
  Attachment: Attachment
  AttentionRequired: Attention Required
  Available: Available to pay out
  AvailableBalance: Available Balance
  AvailableFanPoints: Available FanPoints
  AvailableNow: Available now
  AvailableShares: Available Shares
  AvailableToMembersOn: Available to members on
  BLOCKCHAIN: BLOCKCHAIN
  Balance: Balance
  BankAccountCurrency: Bank account currency
  BankAccountName: Account holder name
  BankAccountNumber: Bank account number
  BankAddress: Bank address
  BankName: BankName
  BeLeave: Uploading in progress, do you want to leave?
  BeLeaveEdit: There are unsaved changes, are you sure you want to leave this page?
  BecomeCreator: Become a creator
  BeenAwarded: You have been awarded
  BindEmailDesc: Connect your dFans account to access your existing content and services.
  Birthday: Birthday
  BirthdayDesc: Must be at least 18 years old
  BlockByCountry: Block by country
  BlockByCountryDesc: Block access to your profile and posts from selected countries.
  BlockByIPAddress: Block by IP address
  BlockByIPAddressDesc: Block access to your profile and posts from specific IP addresses.
  Blocked: Blocked
  Bridge: Bridge
  BridgeETH: Bridge ETH
  Buy: Buy
  BuyETH: Buy ETH with Card
  BuyEtherWithCreditCard: Buy USDT&Ether with Credit Card
  BuyYourFirstShare: Buy Your First Share
  BuyaShare: Buy a Share
  By: By
  ByIpAddress: By IP address
  BySupporting: by supporting
  CHATS: CHATS
  CLOSE: CLOSE
  COLLECTION: COLLECTION
  COLLECTOR: COLLECTOR
  CREATORSLISTS: USER LISTS
  Canceled: Canceled
  CannotSellTheLastShare: Cannot sell the last share
  CardInformation: Card information
  CardNumber: Card number
  CardholderName: Cardholder name
  ChangeEmail: Change Email
  ChangePassword: Change password
  Chat: Chat
  ChatDirectly: Chat directly
  ChatGallery: Chat Gallery
  ChatbotForNSFW: Chatbot for NSFW
  ChatbotForNSFWDesc: >-
    A smart AI assistant that can engage with your customers and help promote or
    sell your digital products (e.g., e-catalogs, artwork). It offers product
    suggestions, answers related questions, and guides users to purchase — all
    through conversation.
  ChatbotForSFW: Chatbot for SFW
  ChatbotForSFWDesc: >-
    A conversational AI designed purely for companionship and engagement. It
    responds warmly and naturally, making it ideal for casual conversations,
    emotional support, or customer interaction.
  ChatbotForSFWTip: This chatbot does not promote or sell any products or content.
  Chats: Chats
  ChooseADepositMethod: Choose a deposit method？
  ChooseAPaymentMethod: Choose a payment method
  ChooseChatbotType: Choose Chatbot Type
  ChooseChatbotTypeDesc: Once the chatbot type is selected, it cannot be changed later.
  ChooseCreditCard: Choose credit card
  City: City
  CityBank: City bank
  ClaimAmount: Claim amount
  ClaimFailed: Claim Failed
  ClaimSubmitted: Claim Submitted
  ClaimedAmount: Claimed amount
  CodeHasBeenSent: Code has been sent
  Collection: Collection
  Collections: COLLECTIONS
  CollectionsDec: Organize content and set price
  Collector: Collector
  Collectors: Collectors
  ComingSoon: Coming soon
  CommentedPost: commented on your
  CompletePurchase: Complete Purchase
  CompleteSale: Complete Sale
  ComposeNewPost: Compose new post
  CompoundedRewards: Compounded rewards from
  ConfirmFIATPayoutRequestDesc: >-
    We have received your fiat currency withdrawal request. Please confirm the
    accuracy of the provided details. We will review and notify you once
    approved.
  ConfirmRelease: Confirm release?
  ConfirmVerificationCode: Confirm Verification Code
  Confirmation: Confirmation
  Congrats: Congrats
  CongratsOnYourNewSocialStatus: Congrats on your new Social Status!
  ConnectComfirm: Connect your dFans account
  ConnectComfirmDesc: Linking your existing dFans account will impact your current subscriptions.
  ConnectEmail: Connect your dFans account
  ConnectError: Connect Error
  ConnectWallet: Connect wallet
  Contact: Contact
  ContactDesc: If you have any questions, please fill out the form below to contact us.
  ContactSupport: Contact support.
  ContentProviderAgreement: Content Provider Agreement
  ContentProviderAgreementDEsc: Please review and agree to all terms before submitting.
  ContentProviderAgreementDesc1: >-
    As a Content Provider on the dFans platform, I hereby acknowledge and agree
    to the following terms:
  ContentProviderAgreementDesc10: ' I will verify the identity and age of every individual featured in my content to ensure that all participants are adults aged 18 years or older. I agree to maintain supporting documentation and to provide it to dFans upon request.'
  ContentProviderAgreementDesc2: 1. Prohibited Activities
  ContentProviderAgreementDesc3: ' I will not engage in or upload any content that involves prohibited, illegal, or otherwise non-compliant activities in violation of applicable laws, regulations, or platform standards.'
  ContentProviderAgreementDesc4: 2. Consent and Documentation Requirements
  ContentProviderAgreementDesc5: ' I will obtain written consent from all individuals depicted in the content I upload and retain such records. This includes, but is not limited to:'
  ContentProviderAgreementDesc6: a. Consent to be visually or audibly depicted in the content;
  ContentProviderAgreementDesc7: ' b. Consent to the public distribution of the content and to upload such content to the dFans platform;'
  ContentProviderAgreementDesc8: ' c. If the content is made available for downloading by other users, consent to allow such downloading.'
  ContentProviderAgreementDesc9: 3. Age and Identity Verification
  ContentProviderAgreementRule: Please agree to the Content Provider Agreement to proceed.
  ContractDetails: Contract Details
  ConversionRatio: Conversion Ratio
  CopyLinkToProfile: Copy link to profile
  CopyLinkToTGProfile: Copy link to Telegram profile
  Copyright: Copyright
  CountdownDraw: Countdown to the draw
  CountryOrProvince: Country or Province
  CountryOrRegion: Country or region
  CreateNewLabel: Create new label
  CreateTime: Create time
  CreateYourAIPersona: Create your AI persona
  CreateYourAIPersonaDesc: >-
    Converted to USDT for free by dFans. Settlement time depends on the
    third-party payment provider.
  CreateYourAccount: Create your account
  CreateYourExclusiveDFansPage: Create your exclusive dFans page
  CreateYourSocialStatusondFans: Create Your Social Status on dFans
  Creator: Creator
  CreatorFollower: CREATOR FOLLOWER
  CreatorIncome: Creator income
  CreatorReward: Creator reward
  CreatorRewardDesc: You can get shares equivalent to 1% of your earnings.
  Creators: Creators
  Crypto: Crypto
  CryptoPayments: Crypto Payments
  CryptoPaymentsDesc: Supports USDT, USDC, ETH, SOL for all payment scenarios.
  CryptoWithdrawals: Crypto Withdrawals
  CryptoWithdrawalsDesc: >-
    Withdraw in USDT, USDC, ETH, or SOL with a settlement time of less than 24
    hours.
  Curated: Curated!
  Currency: Currency
  CurrentSocialStatus: Current Social Status
  CustomName: Custom name
  DATE: DATE
  DATEPAID: DATE PAID
  DATE_COLLECTED: DATE COLLECTED
  DAYSCHEDULE: DAY SCHEDULE
  DAYS_LEFT: DAYS LEFT
  DFANS_POINTS: DFANS POINTS
  DFSBalance: DFS Balance
  DFansBalance: dFans balance
  DFansBlog: dFans Blog
  DFansClub: dFans Club
  DFansOperationalData: dFans Operational Data
  DFansPoints: dFans Points
  DFansShareholder: dFans Shareholder
  DISTRIBUTION: DISTRIBUTION
  DIVIDENDS: DIVIDENDS
  Daily: Daily
  DailyDesc: '* Daily dividends will be calculated based on the platform''s net profit.'
  DailyDividendAmount: · Daily dividend amount
  DarkMode: Dark mode
  Date: Date
  DateAndTime: DATE & TIME
  Day: Day
  Days: days
  DaysCapital: Days
  DaysStaked: ' Days Staked'
  DeactivationAppealForm: Deactivation Appeal Form
  DeactivationAppealFormDesc1: >-
    We do not tolerate content or behavior that violates our Terms of Service or
    our Acceptable Use Policy.
  DeactivationAppealFormDesc2: >-
    To keep our community safe, we moderate all of the content on dFans
    including direct messages. If you post content that is not allowed on dFans,
    it will be deactivated and we may suspend or terminate your dFans account.
  DeactivationAppealFormDesc3: >-
    Our <span class="text-darkBrandRed dark:text-brandRed">Terms of Service or
    Acceptable Use Policy</span> and <span class="text-darkBrandRed
    dark:text-brandRed">Community Guidelines</span> set out in detail what is,
    and what is not, allowed on dFans. <br>
        Our <span class="text-darkBrandRed dark:text-brandRed">Creator's Guide to Content Moderation</span> sets out the most common reasons content is removed from dFans. Please read this before completing this form.
  DeactivationAppealFormDesc4: >-
    If your content and/or account has been deactivated and you have evidence
    that you have not violated our <span class="text-darkBrandRed
    dark:text-brandRed">Terms of Service or Acceptable Use Policy</span> please
    complete the form below.
  DeactivationAppealFormDesc5: >-
    Your appeal and any supporting evidence will be carefully considered. If you
    do not provide detailed evidence that you did not violate dFans Terms of
    Service, Acceptable Use Policy and/or Community Guidelines, we cannot
    consider your appeal and it will be denied.
  DeactivationAppealFormDesc6: >-
    Any decision reached by dFans regarding the deactivation of content or your
    account will be made in keeping with our Appeals Policy.
  DeactivationAppealFormDesc7: User Name/ID/Email/Profile Link
  DeactivationAppealFormDesc8: >-
    Please describe all relevant details of the Content or the Account in
    question and specify the time when it was deactivated. Explain why you
    believe the deactivated Content or Account was in keeping with dFans <span
    class="text-darkBrandRed dark:text-brandRed">Terms of Service</span> and
    <span class="text-darkBrandRed dark:text-brandRed">Acceptable Use
    Policy</span>
  DeactivationAppealFormDesc9: If you do not provide detailed reasons, your appeal will be denied
  Default: Default
  Definition: Definition
  DeleteCard: Delete Card
  DeleteCategory: Delete category
  DeleteCategoryDesc: Are you sure you want to delete this vault category?
  DeleteCategoryDesc1: Also permanetly remove all category medias from Vault
  DeleteContract: Delete Collection?
  DeleteLabel: Delete label?
  DeletePayoutWallet: Delete payout wallet
  DeleteVaultDesc: 'Are you sure you want to delete these media from Vault entirely? '
  DeleteVaultDesc1: >-
    To add or remove media from a specific category please use "Add to category"
    button.
  DeleteVaultTitle: Delete selected media?
  Deposit: Deposit
  DepositAddress: Deposit Addresss
  DepositAmount: Deposit amount
  DepositArrival: Deposit arrival
  DepositDecs: The fastest 30 seconds to arrive
  DepositNetwork: Deposit Network
  DepositOnChain: '{currency} On-Chain Deposit'
  DepositTitle: Deposit
  DepositWarning: >-
    The current address only supports depositing {currency} on {network},
    depositing other assets will result in loss.
  Descending: Descending
  Description: Description
  Details: Details
  DifferencesFromOtherPlatforms: What sets us Apart?
  DirectMessage: Direct Message
  Discover: Discover
  DiscoverOnDFans: Discover on dFans
  Disputed: Disputed
  DisputedAmount: Disputed amount
  DisputedFee: Disputed fee
  DisputedFeeDesc: The fee charged for challenging this dispute by the payment provider.
  DistributeAmount: Distribute amount
  DividendRewards: Dividend Rewards
  Dividends: Dividends
  EARLIER: EARLIER
  EDITPOST: EDIT POST
  ETHSettlementAmount: ETH settlement amount
  ETHValue: ETH Value
  EarnDailyDividends: Earn Daily Dividends
  EarnLink: Earn 1.5% lifetime cashback
  EarnPoints: Earn points by inviting users
  EarnPointsSimple: Earn points
  Earning: ETH Earning
  EarningsDataUpdates: Earnings data updates every 24 hours.
  EditBankAccount: Edit bank account
  EditBenefit: Edit Benefit
  EditNotes: Edit notes
  EditProfile: Edit Profile
  Email: Email
  EmailDec: This email might be in spam—it's not junk.
  EmailDecs: You have not linked your email address yet.
  EmailErrorDec: This email is already used by other users. Please change to another one.
  EmailIsNotVerified: ' {email} is not verified'
  EmailNotifications: Email notifications
  EmailNotificationsDesc: >-
    Get emails to find out what’s going on when you’re not on dFans. You can
    turn them off anytime.
  Empty: empty
  EnableAIChat: Enable AI chat for selected followers
  EnableImageWatermarking: Enable image watermarking
  EnablePushNotifications: Enable Push Notifications
  EnablePushNotificationsDesc: >-
    Get real-time updates! 🔔 Enable push notifications for instant alerts on
    messages and account activities. Stay connected -turn on notifications now!
    🚀
  EnablePushNotificationsDesc1: Get push notifications from your fans when you’re not on dFans.
  EnablePushNotificationsDesc2: >-
    Notifications are blocked. Please grant notification permissions in your
    browser.
  EnablePushNotificationsOnThisDevice: Enable Push notifications on this device
  End: End
  EnterAudioName: Enter audio name
  EnterVerificationCode: Enter verification code
  EveryCreatorEarns: Every creator earns (USD)
  Everyone: Everyone
  EveryoneDesc: Everyone can access this post
  Example: 'Example: '
  ExchangeUSD: Exchange USD for ETH
  ExpectedTime: Expected time 0.5 - 30 mins
  ExpireSubscriptionDecs: >-
    Your subscription to <span class="font-bg domain_{domain}_{id} text-gradient
    cursor-pointer">{Symbol}{creatorName}</span> will expire in {day} days.
    Enable renewal to continue the access.
  Expired: Expired
  ExpiredSubscriptionDecs: ' Your creator subscription of <span class="font-bg domain_{domain}_{id} text-gradient cursor-pointer">{Symbol}{creatorName}</span> renewal has failed, and your benefits will not be accessed. Please renew to continue using them.'
  ExpiryDate: Expiry date
  Explore: Explore
  FOR: For
  Failed: Failed
  Fanclub: Fanclub
  Fans: Fans
  FansWarning: >-
    Maximize Your Creative Earnings. dFans is a decentralized subscription
    platform for Generations X, Y, and Z.
  FastAndGlobal: Fast and Global
  FastAndGlobalDesc: Send payments anywhere, instantly.
  FeaturedProject: Featured Project
  FeeRate: Fee Rate
  Feed: Feed
  Fees: Fees
  Female: Female
  Fiat-to-CryptoTop-Up: Fiat-to-Crypto Top-Up
  Fiat-to-CryptoTop-UpDesc: >-
    Ideal for fans without crypto. Powered by Alchemy Pay with a 6.5% fee
    covered by dFans.
  FiatPayments: Fiat Payments
  FiatPaymentsDesc: >-
    Available upon request. Requires acceptance of the dispute agreement; if
    disputes exceed 0.5%, settlements may be delayed or the channel may be
    closed.
  FiatWithdrawalServiceNotice: Fiat Withdrawal Service Notice
  FiatWithdrawalServiceNoticeDesc1: 1. Once enabled, fiat withdrawal will replace crypto withdrawal.
  FiatWithdrawalServiceNoticeDesc2: 2. Funds will be sent to your linked bank account.
  FiatWithdrawalServiceNoticeDesc3: 3. Fees and processing time vary by country and bank.
  FiatWithdrawalServiceNoticeDesc4: 4. Exact details will be available after activation.
  Filter: Filter
  FindCreators: Find Creators
  FlexibilityClaim: Flexibility to claim staking dividends
  Follow: Follow
  FollowTheCreatorBeforeSendingMessage: Follow the creator before sending message!
  FollowYourFavoriteCreators: Follow your favorite creators
  Follower: Follower
  Following: Following
  For: for
  ForCreator: For creator
  ForFans: For fans
  ForgotPassword: Forgot password?
  FreeFor: Free for
  FreeForFans: Free for fans
  FreePreview: Free preview
  FreeSubscriptionDecs: >-
    Your free trial subscription to <span class="font-bg domain_{domain}_{id}
    text-gradient cursor-pointer">{Symbol}{creatorName}</span>  is ending soon.
    Subscribe now to continue the access.
  FreeTrial: after your {0} days free trial ends.
  FrequentlyAskedQuestions: Frequently asked questions
  Friends: Friends
  From: From
  FromEthereumMainnet: From Ethereum Mainnet
  FulfillYour: Fulfill your
  GENRE: GENRE
  GET_BENEFITS: SUBSCRIBE AND GET THESE BENEFITS
  Gas: Gas
  GasEstimated: Gas (estimated)
  GasFee: Gas Fee
  GasFeeCapital: Gas Fee
  GatewayFee: Gateway Fee
  GaveYou: paid you a tip of
  GenesisCollection: Genesis Collection
  GetLink: Get link
  GetLinkDesc: You can download the media file to your computer using the link within.
  GetRewardsEveryDay: Get rewards every day
  Global: Global
  GoTo: Go to
  GoToDate: Go to date
  GrossProfit: Gross Profit
  HISTORY: HISTORY
  HiWelcome: Hi, Welcome!
  Hide: Hide
  HighApprovalRate: High approval rate
  Highlighting: Enable tier highlighting
  History: History
  Hobbies: Hobbies
  Holders: Holders
  Holding: Holding
  HowShareholdersRealize: How do shareholders realize profits?
  HowToGetSharesFree: How to get Shares for free?
  HowToTopUpViaBinance: How to top-up via Binance
  HowToTopUpViaCoinbaseWallet: How to top-up via Coinbase Wallet
  IAcknowledgeAndAgreeThat: I acknowledge and agree
  IBAN: IBAN
  IPaddressDecs: >-
    Please use the following format 1.2.3.4 for a single IP address, 1.2.3.4/24
    for networks or 1.2.*.4 for wildcard masks. Each address on the new line.
  ITEM: ITEM
  IncludedTiers: Included Tiers
  IncludedTiersDesc: >-
    The higher-priced subscription tier <span class="text-[#FCD535]">includes
    all benefits from the lower-priced tiers</span>, giving subscribers access
    to all content available across those tiers.
  Install: Install
  InstallApp: Install app
  InstallTheDFansAppNow: Install the dFans app now!
  InstallTheDFansAppNowDesc: >-
    Get the better experience, improved performance, and access dFans quicker
    from your home screen.
  InsufficientBalance: Insufficient balance, deposit with card
  InsufficientFunds: Insufficient Funds
  InvestInfluencers: Invest in influencers
  InvestedItems: Invested items
  Investment: Investment
  Investors: Investors
  InvitationCode: Invitation Code
  InvitationLink: Invitation Link
  InviteCreators: Invite Creators
  InviteFans: Invite Fans
  InvitedCreatorsNum: Number of invited creators
  ItemsCapital: Items
  ItemsMintedSimple: Items minted
  JackpotWinner: Jackpot Winner
  JoinAPlatformThatCares: Join a platform that cares
  JoinDfans: Join dFans - The Decentralized Creator's Platform!
  JoiningDate: Joining date
  KadoFor: for cryptocurrency purchases
  LabelName: Label name
  Labels: Labels
  Language: Language
  LanguageRequired: Please select language
  LatestEarnings: Latest earnings analysis
  LatestFeaturedPosts: Powerful features for creators
  LearnMore: 'Learn more:'
  LegalBusinessName: Full name of the account holder
  LightMode: Light mode
  ListName: List name
  LoadingDesc: Just a moment - payment is now loading.
  Locked: Locked
  LogIn: Log in
  LogInTo: Log in to SUBSCRIBE
  LogInWithVerificationCode: Log in with verification code
  LoginUsers: Login users
  LoginWallet: Login wallet
  MESSAGES: MESSAGES
  MakePayment: Make Your Payment
  Male: Male
  MassMessagesStatistics: Mass messages statistics
  MaxSize: max size
  MaxWithdrawable: Max Withdrawable
  Media: Media
  MessageBuyers: Message buyers
  MessageMedia: Message Media
  MessagePrice: Message price
  MessageRemind: Only paying users can send messages
  Messages: Messages
  MessagesWithTips: Messages with tips appear at the top of recipient inbox
  MinimumDeposit: Minimum deposit
  Month: month
  MoreSubscriptions: SUBSCRIPTION BUNDLES
  MoreWaysToLogIn: More ways to log in
  MyBankAccount: My bank account
  MyCryptoWallet: My Crypto Wallet
  MyDividends: My Dividends
  MyPayments: ' My Payments'
  MyStakedDFS: My Staked Share
  MyStakedShares: My Staked Shares
  MyVeDFS: My veShare
  MyWallet: My Wallet
  NEWMessage: NEW MESSAGE
  NEWPOST: NEW POST
  NFTSold: NFT sold
  Name: Name
  NetAmount: Net amount
  NetProfit: Net Profit
  NewCollectionPurchase: New Collection Purchase
  NewComment: New Comment
  NewFollower: New Follower
  NewLikes: New Likes
  NewMessage: New message
  NewMessageToSelectedList: NEW MESSAGE TO SELECTED LIST
  NewMessageToUsers: New message to all users
  NewMessages: New messages
  NewPaidMessage: New Paid Message
  'NewPaymentReceived:': New Payment Received
  NewPostPurchase: New Post Purchase
  NewPostsSummary: New Posts Summary
  NewSubscriber: New Subscriber
  NewSubscriptionFromTrail: New Subscription from trail
  NewSubscriptionPost: New Subscription Post
  NewTip: New Tip
  'No': 'NO'
  NoBillingRecords: No Billing Records
  NoBillingRecordsDesc: No monthly statements to track.
  NoData: No Data
  NoMoreData: No more data
  NoPermissions: this page is not available
  NoPermissionsDesc: The link you followed may be broken, or the page may have been removed.
  NotAvailable: Unavailable for selected combination
  Notes: Notes
  NothingFound: Nothing Found
  NudityNotAllowed: Nudity is not allowed in your dFans Bio/Avatar.
  NumShares: '{num} Shares '
  OR: OR
  On-ChainDeposit: On-Chain Deposit
  OpenExternalBrowser: then open in external browser
  OpenExternalBrowserAlert: Please tap ··· then open in external browser to complete sign-in process.
  OperationCost: Costs
  OptionalBrackets: (optional)
  Or: or
  Others: others
  PAYMENTMETHOD: PAYMENT METHOD
  POST: POST
  POSTS: POSTS
  POST_LABELS: POST LABELS
  PPVMESSAGE: P-P-V-MESSAGE
  PPVSettingDesc: >-
    Remove the PPV price before changing the post to a subscription or adding it
    to a collection.
  PRIZE_POOL: PRIZE POOL
  PRODUCT_RULES: PRODUCT RULES
  PageLoadFailed: ' The website content has been updated. Please refresh the page and try again.'
  PaidCollection: Paid Collection
  PaidTo: PAID TO
  PaidUsers: Paid users
  PayCryptoDesc1: Crypto payments offer better privacy with no billing records.
  PayCryptoDesc2: >-
    No Crypto yet - just click "Pay with Crypto" and top up instantly with your
    credit card.
  PayCryptoDesc3: Credit card top-ups powered by
  PayTips: Please be aware that digital products are non-refundable.
  PayTopUpDesc: An additional payment processing fee applies.
  PayTopUpDesc2: The minimum top-up amount is USD {amount}.
  PayUsing: Pay using
  PayWithCard: Pay with Card
  PayWithCreditCardDesc1: Unlock exclusive content under this subscription
  PayWithCreditCardDesc2: Cancel anytime with no restrictions
  PayWithCreditCardDesc3: Unlock exclusive content for 30 days
  PayWithCreditCardDesc4: 'Top up crypto instantly with credit card '
  PayWithETH: Pay with ETH
  PayWithSOL: Pay with
  PayWithSaferCrypto: Pay with Crypto
  PayWithTelegramStars: Pay with Stars
  PayWithUSDC: Pay with USDC
  PayWithUSDT: Pay with USDT
  PaymentAmount: Payment amount
  PaymentBreakdown: Payment Breakdown
  PaymentFailed: Payment Failed!
  PaymentGatewayManagement: Payment Gateway Management
  PaymentGatewayManagementDesc: >-
    The payment gateway enables fans to pay creators and is provided by
    third-party payment companies.
  PaymentInstruction: Your top-up is for subscribing to creators or buying their content.
  PaymentMethod: Payment Method
  PaymentRequestIsBeingProcessed: Your payment request is being processed.
  PaymentRequestIsBeingProcessed2: 'This may take up to 40 seconds. '
  PaymentRequestIsBeingProcessed3: Please wait until it’s complete.
  PaymentSuccessful: Payment Successful！
  PaymentsDesc: We are fully compliant with Payment Card Industry Data Security Standards.
  PaymentsTip: >-
    By linking your card, you acknowledge and accept the <a target="_blank"
    href="https://about.dfans.xyz/Credit-Card-Binding-and-Payment-Disclaimer.html"><span
    class="cursor-pointer dark:text-brandYellow typeface-robotoMedium
    text-darkBrandYellow">“Credit Card Binding and Payment
    Disclaimer”</span></a>.
  Payouts: Payouts
  PayoutsManagement: Payouts Management
  PayoutsManagementDesc: >-
    Creators can withdraw crypto earnings directly in the same currency, while
    USD earnings are converted to USDT for free by dFans.
  Pending: Pending for payout
  Per: per
  PercentageOfCreatorsEarnings: Percentage of Creators' Earnings (%)
  PinToYourProfilePage: Pin to your profile page
  PlatformOperatingCosts: Platform operating costs
  PlayingDesc: The purchase has been submitted and is currently being processed.
  PleaseAddALabel: Please add a label
  PleaseAddFundsToContinue: Please add funds to continue
  PleaseEnterTheCorrectAddress: Please enter the correct address.
  PleaseSelectTheSettlementCurrency: Please select the settlement currency
  PleaseWait: Please wait .....
  Point: Point
  PointHistory: Point History
  Points: Points
  PointsLower: points
  PointsRankings: dFans Points Rankings
  Portfolio: Portfolio
  PortfolioValue: Portfolio Value
  Post: post
  PostBuyer: Pay-Per-View
  PostLikes: Post Likes
  PostPrice: Post Price
  Posts: Posts
  PostsYouHaveAccessTo: Posts you have access to
  PoweredBy: Powered by
  Preferences: Preferences
  Price: Price
  PricePerMonth: Price per month
  PriceRange: Minimum $5 USD,  Maximum $200 USD.
  PriceRangeBundles: Minimum $4.99 USD or free.
  PriceTime: You can change the price only 30 days after the creation date.
  PriceToView: Price to view
  Privacy: Privacy
  PrivacyAndSafety: Privacy and safety
  PrivacyAndSafetyUpperCase: PRIVACY AND SAFETY
  PrivacyPolicy: Privacy Policy
  PrizePoolRules: Prize Pool Rules
  ProcessingImage: Processing Image
  ProcessingTimeframe: Processing Timeframe
  ProcessingVideo: Processing Video
  ProfilePromotionCampaign: Profile promotion campaign
  ProfileUpperCase: Profile
  Prompt: Information
  ProtectYourPrivacy: Protect Your Privacy
  ProtectYourPrivacyDesc: Your personal data stays secure.
  PurchaseDetails: Purchase Details
  Purchased: Purchased
  PushNotifications: Push notifications
  QUEUE: QUEUE
  QuickTip: 'Quick Tip: '
  REACH: REACH
  REFERRAL_LINK: REFERRAL LINK
  RENEW: RENEW
  REQUIRED: REQUIRED
  Ramp: Ramp
  Ratio: Ratio
  RearrangePhotos: Rearrange photos
  Receipt: Receipt
  ReceiptFrom: Receipt from
  Receive: Receive
  RecentDrops: Recent Drops
  RecentPayments: Recent Payments
  RecentlyViewed: 'Recently Viewed:'
  RechargeRecord: Recharge record
  RecipientWallet: Recipient wallet address
  Recommended: Recommended
  RedeemAmount: Redeem amount
  RedemptionDate: Redemption Date
  Refer: Refer
  ReferenceAPR: Reference APR
  ReferralETHEarnings: Referral ETH earnings
  ReferralFee: Referral fee
  ReferralHistory: Referral History
  ReferralLink: Referral Link
  ReferralReward: Referral reward
  ReferralRewardCalculator: Referral Reward Calculator
  ReferralRewardDesc: You can get shares equivalent to 5% of your invitees' earnings.
  ReferralUSDEarnings: Referral USD earnings
  Referrals: Referrals
  ReferralsEarnings: Referrals earnings
  ReferralsEarningsDetails: Referrals earnings details
  ReferredCreators: Referred creators
  ReferredUsers: Referred users
  RegularPrice: Regular price
  RelatedToYouAndYourPosts: Related to you and your posts
  Reload: Reload
  Remark: Remark
  RenameCategory: Rename category
  RenameLabel: Rename label
  Required: Required
  RequiredFields: Required fields
  Resend: Resend
  ResendCode: Resend the verification code
  RestoreAccess: Restore access
  Restricted: Restricted
  Revenue: Revenue
  RevenueShare: Revenue Share
  RewardPercent: Reward Percent
  RewardRules: Reward Rules
  RewardWithETH: Tip with ETH
  RewardWithTelegramStars: Tip with Telegram Stars
  RewardsDividends: Rewards Dividends
  RewardsStartAccruing: Rewards Start Accruing
  RoutingNumber: Routing number
  Rules: Rules
  SCHEDULE: SCHEDULE
  SCHEDULEDEVENTS: SCHEDULED EVENTS
  SCHEDULEPOST: SCHEDULE POST
  SEND_TO: SEND TO
  SOLValue: SOL Value
  STAKE: STAKE
  STATEMENTS: STATEMENTS
  SUMMARY: SUMMARY
  SafeAndSecure: Safe and Secure
  SafeAndSecureDesc: No credit card fraud or data breaches.
  SaveCard: Save card
  Scheduled: Scheduled
  ScheduledDec: There are no schedule events for this day
  ScheduledDesc: Please choose a date and time for your action to be executed.
  Search: Search
  SecretPictorials: secret pictorials
  SeeLess: Collapse info
  SeeMore: More info
  SeePost: Who can see this post?
  SeePostDesc: Allow your subscribers to explore your work with related posts.
  SeePostDesc1: Help fans explore your work with collections of related posts.
  SeePostDesc2: Offer several months of subscription as a discounted bundle.
  Select: Select
  SelectACurrency: Select a Currency
  SelectANetwork: Select a Network
  SelectANetworkDesc: >-
    Ensure the network you choose to deposit matches the withdrawal network, or
    assets maybe lost.
  SelectAmount: Select an amount to exchange
  SelectTOP-UPCurrency: Credit card top-up for Crypto
  SelectTOP-UPCurrency2: Select the third-party payment
  SelectTopUpAmount: Select Top Up Amount
  SelectUsersToSend: SELECT USERS TO SEND THEM A MESSAGE
  Selected: Selected
  SellaShare: Sell a Share
  Send: Send
  SendMessage: Send message
  SendSuccess: Send success
  SendTip: Send Tip
  SendTo: Send to
  SendToPostInANewTab: Send to post in a new tab
  SendWelcomeMessage: Send a welcome message to new fans
  Sent: Sent
  SentVerificationCode: ' We’ve sent a verification code to'
  ServiceWallet: Service Wallet
  SetChat: Don't access messages from free followers
  SetPassword: Set password
  Settings: Settings
  SettlementAmount: Settlement amount
  Sex: Sex
  Share: Share
  ShareAmount: Share amount
  ShareClaimDate: Share Claim Date
  ShareDistributionDate: Share Distribution Date
  ShareDividendsContent1: >-
    If 100 Shares are being staked, their allocated veShare (Dividend
    Coefficient) would be
  ShareDividendsContent2: >-
    if three shareholders stake, their allocated veShare (Dividend Coefficient)
    would be
  ShareDividendsContent3: >-
    If the platform distributes 1,000 Shares and only above three shareholders
    stake, the dividends would be distributed based on their veShare ratio:
  ShareDividendsTitle: How many share dividends can I get?
  ShareDividendsTitle1: 1. Calculate daily dividend coefficient
  ShareDividendsTitle2: 2. Determine proportion of the daily dividend pool
  ShareDividendsTitle3: 3. Share daily platform profit
  ShareHistory: share history
  SharePrice: Share price
  ShareRewards: Share rewards
  ShareValue: Share Value
  Shares: Shares
  SharesForYourStakingReward: shares for your staking reward
  SharesRewardRorYourTransaction: Shares reward for your transaction
  Show: Show
  ShowWhoLikesPost: Show who liked this post
  SignIn: Sign In
  SignUp: Sign up
  SignUpForDFans: Sign up for dFans
  SignUpThisMonth: Sign up this month,
  SkipTheWait: Skip the wait
  Sorry: Sorry
  SortCode: Sort code
  SortOrderDec: Sort order photos by drag and drop.
  Source: Source
  Spent: spent
  SpreadTheWordToMoreFans: Spread the Word to More Fans!
  StakeAmount: Stake amount
  StakeDFansShares: Stake dFans shares to earn everyday dividends
  StakeDate: Stake Date
  StakeFailed: Stake Failed
  StakePeriod: Stake period
  StakePeriodTitle: Stake Period
  StakeShares: Stake Shares
  StakeSuccessfully: Stake Successfully
  Staking: Staking
  StakingPeriod: Staking period
  StakingPeriod2: Staking Period
  StakingReward: Staking reward
  StakingRewardDesc: You can claim share staking dividends everyday.
  StakingShares: Staking Shares
  StakingTransactions: Staking Transactions
  StartAIChatCompanion: Start AI Chat Companion (Trial)
  StartEarning: Start earning in 3 steps
  StartVerification: Start Verification
  State: State
  StateProvince: State / Province
  Status: Status
  Step: Step
  Step1ConfirmBankingDetails: Step 1. Confirm Banking Details
  Step2ConfirmFIATPayoutRequest: Step 2. Confirm FIAT Payout Request
  SubscribeAndGet: SUBSCRIBE AND GET
  SubscribeTelegramStars: Subscribe with Telegram Stars
  Subscribed: Subscribed
  Subscriber: Subscriber
  SubscriberTier: Subscriber Tier
  Subscription: Subscription
  SubscriptionBundles: Subscription bundles
  SubscriptionBundlesDec: Offer several months of subscription as a discounted bundle.
  SubscriptionBundlesDesc: Offer several months of subscription as a discounted bundle.
  SubscriptionConfirmation: Subscription Confirmation
  SubscriptionDec: Subscription price and promotions
  SubscriptionPurchase: ' Subscription Purchase'
  SubscriptionTiers: Subscription Tiers
  SubscriptionTiersUpperCase: SUBSCRIPTION TIERS
  SubscriptionUpgrade: Subscription Upgrade
  SubscriptionsAndFollowing: Subscriptions and following
  Successfully: Successfully
  Summary: Summary
  SuperCashback: Super Cashback, Up to 5%
  Support: Support with
  SupportedBy: Supported by
  Suspended: Suspended
  Swift: Please enter the Swift/BIC
  SwitchTheView: Switch the view
  SwitchToPayWith: 'Switch to pay with '
  TOTALFOLLOWERS: TOTAL FOLLOWERS
  TYPE: TYPE
  Tagline: Tagline
  Tags: Tags
  Tap: Tap
  TermsService: Terms of Service
  Text: Text
  TheHigherYourStatus: The higher your status.
  TheMoreFansBuy: The more fans buy,
  TheSocialstatuswillDown: The Social status will Down
  TheSocialstatuswillUp: The Social status will Up
  ThirdPartyPayment: Third-party payment
  ThisWeek: This Week
  TierBenefits: Tier Benefits
  Time: Time
  Tip: Tip
  TipAmount: Tip amount
  TipWithETH: ' Tip with ETH'
  To: To
  ToPrizePool: to Prize Pool
  Today: Today
  TodayDividends: Today’s Dividends
  Top: Top
  Top-Up: TOP-UP
  Top-upEther: Top-up Ether
  Top20: Top 20
  TopUp: Top up
  TopUpCancel: Top Up cancel!
  TopUpDec: >-
    You’ll need some ETH to get started using the rest of the app. We recommend
    at least 0.01 ETH (~$20).
  TopUpDecs: >-
    Top up with a credit card to buy creator content, with no billing records
    and full privacy protection.
  TopUpFirstThen: Top Up First, Then {type}
  TopUpPoints: Top-up Points
  TopUpSuccess: Top Up successful!
  Total: Total
  TotalDividends: Total dividends
  TotalDividendsAmount: Total Dividends Amount
  TotalEarnings: Total Earnings
  TotalFanPoints: Total FanPoints
  TotalInviteesUper: Total Invitees
  TotalRaised: Total Raised
  TotalReferrals: Total Referrals
  TotalRevenue: Total Revenue
  TotalRevenue2: Total Revenue
  TotalRevenueUper: Primary Balance
  TotalSales: Total Sales
  TotalShares: Total Shares
  TotalSpent: Total Spent
  TotalStakingUsers: Total Staking Users
  TownOrCity: Town or City
  TrackingLink: Tracking links
  TrackingLinkName: Tracking link name
  TrackingLinkUpperCase: TRACKING LINKS
  TransactionFees: Transaction fees are charged by third-party platform.
  TransactionNumber: Transaction number
  TransactionRewards: Transaction rewards
  Transactions: Transactions
  TransferCompleted: Transfer completed
  TransferDfansWallet: Transfer to dFans Wallet
  TransferIn: Transfer in
  TransferTo: Transfer to
  TransferWallet: Transfer to your wallet
  TransferringETH: Transferring {currency}
  TransferringUSDT: Transferring USDT
  Trending: Trending
  TxnHash: Txn Hash
  Type: Type
  USDEarningsWithdrawal: USD Earnings Withdrawal
  USDEarningsWithdrawalDesc: >-
    Withdraw earnings in local currency. Fees and timing depend on your bank and
    country.
  USDEarningsWithdrawalSuspended: 'Services are unavailable in your region. '
  USDOrLocalCurrency: USD or Local Currency
  USDSettlementAmount: USD settlement amount
  USDTValue: USDT Value
  USDWithdrawalDetails: USD withdrawal details
  Unavailable: Unavailable for selected combination
  UnionPay: UnionPay
  UnionPayAlipayEarningsWithdrawal: >-
    Converted to USDT for free by dFans. Settlement time depends on the
    third-party payment provider.
  UnionPayAlipayEarningsWithdrawalDesc: >-
    Converted to USDT for free by dFans. Settlement time depends on the
    third-party payment provider.
  UnionPayAlipayPayments: Available upon request. Payouts to creators will be converted to USDT.
  UnionPayAlipayPaymentsDesc: Available upon request. Payouts to creators will be converted to USDT.
  UniqueDesires: unique desires
  UniqueDomain: Unique domain
  Unlock: Unlock
  UnlockContent: Unlock exclusive content
  UnlockPictorials: Unlock secret pictorials
  UnlockWith: Unlock with
  Unlocked: Unlocked
  UnpinAPostToPinANewOne: '* 5 pinned posts already, the newest one automatically replaces the oldest'
  UnpinFromYourProfilePage: Unpin from your profile page
  UnsenInfo: >-
    This will delete this message for all recipients who did not purchase the
    content in this message.
  Unsend: Unsend
  UnsendConfirm: >-
    Those who have purchased content in this message will continue to be able to
    view it in their “Purchased” tab.
  UnsendConfirmText: YES, UNSEND
  UpTo: Up to
  UpTo1Video: Up to 1 video
  UpTo5Pictures: Up to 50 pictures
  UploadFailed: Upload failed
  UploadPaidPhotos: Upload paid photos
  UploadPaidPhotosDesc: >-
    These photos will be inserted into conversations as paid content,
    encouraging fans to purchase.
  Uploading: Uploading
  UsdEarnings: USDT Earning
  Username: Username
  VALID_TERM: VALID TERM
  VERIFY_YOUR_CREATOR_ACCOUNT: VERIFY YOUR CREATOR ACCOUNT
  VIEWQUEUE: VIEW QUEUE
  Value: Value
  VerificationCode: Verification code
  Verified: verified
  VerifiedCreatorApplication: Verified Creator Application
  VerifyDecs: You have not verify your account yet
  Video: Video
  View: View
  Viewed: Viewed
  Visitors: Visitors
  Vistors: Vistors
  WITHDRAW: WITHDRAW
  Wallet: Wallet
  WalletAddress: Wallet address
  WalletBalance: Your wallet balance
  WalletBalanceSimple: Wallet Balance
  WalletBalanceTitle: Wallet balance
  WaysToEarnMoney: Ways to earn money
  WeAccept: Accept
  Wealth: Wealth
  Week: Week {weekNum}
  WelcomeMessage: Welcome message
  WelcomeToDFans: Welcome to dFans
  WhatAreShareDFS: What are Share and DFS ?
  WhatIsDFSTitle: What is DFS?
  WhatIsShare: What is Share?
  WhatSetsUsApart: Advantages of A Decentralized Platform
  WhoCanSee: Who Can See
  WhoCanSee1: Who can see this post?
  WhoCanSeeDesc: Make your work accessible for all your fans to explore freely.
  WhyDecentralize: Why decentralize?
  WhyUseCryptocurrencyForPayments: Why use cryptocurrency for payments?
  WinningRecord: Winning record
  With: with
  WithCreators: with creators
  Withdraw: Withdraw
  WithdrawConfirmation: Withdraw Confirmation
  WithdrawableEarn: Withdrawable Earn
  WithdrawableRevenueUper: Pending Balance
  WithdrawableSoonDesc: >-
    Payments are generally settled by the payment processor in seven days or
    more.
  WithdrawalHistory: Withdrawal history
  YESTERDAY: YESTERDAY
  YOURCARDS: YOUR CARDS
  YOU_GET: YOU GET
  YOU_HAVE: YOU HAVE
  YOU_MIGHT_LIKE: YOU MIGHT LIKE
  Year: Year
  Yesterday: Yesterday
  You: You
  YouBalanceDetails: Your {currency} balance details
  YouCanNow: >-
    To unlock more platform features and support, please proceed with age
    verification (KYC) as soon as possible. This helps us maintain a safe and
    trusted environment for all users. 
  YouGet: You get
  YouPurchased: You purchased
  YouReceived: You received
  YouSpend: You spend
  YouSpent: You spent
  YouWallet: You Wallet
  YouWillWin: You will win
  Youhold: You hold
  YourAnonymousIdentity: Your Anonymous Identity
  YourBalance: Your Balance
  YourBalanceIsTooLow: Your balance is too low
  YourBeCharged: Your will be charged
  YourChoice: Your choice
  YourDFansPageIs: Your dFans profile page link
  YourETHBalance: Your ETH balance
  YourFirstShareIsFree: Your first Share is free.
  YourPersonalReferralUrl: Your personal referral url
  YourStatusIsDeterminedByShareholders: Your status is determined by shareholders
  YourUSDTBalance: Your {currency} balance
  ZipCode: ZIP code
  aiChatsDesc: AI Chat Companion is currently in a free trial phase—give it a try!
  aiChatsTitle: Start AI Chat Companion (Trial)
  available: available
  bindEmail: Link Email
  bindEmailDec: This linked email will be used to receive the verification code.
  bought: bought
  buttonAbove: button above
  changeUsername: Change username
  chooseCoverPicture: Choose Cover Picture
  collectionDesc: >-
    Please ensure that the uploaded cover image does not contain any explicit or
    nudity-related content.
  collectionInfoDec: >-
    Please be aware that this collection DOES NOT include access to any media
    content.
  comment: comment
  comments: comments
  commentsBlockDisabled: You can only comment after unlocking
  commentsTip: Show post comments
  commentsTipDisabled: You can only comment after unlocking the media
  contractDeployed: collection deployed
  contractDeploying: collection deploying
  copyright: © Copyright {year} dfans.xyz. All Rights Reserved
  creatorDecs: what attracts you to dFans and what do you want to use it for? (optional)
  declined: Declined
  deleteUserDec: "Enter the verification code we just sent to\_{email} if you want to proceed:"
  deployArbitrum: Deploy Collection on Arbitrum
  deployEthereum: Deploy Collection on Ethereum
  deposit: Deposit
  desc4: Fans pay USD, Creator payout USDT
  downloadVideosImagesDesc: Allow subscribers to download videos & images from your posts
  droppedCollection: dropped 1 collection
  earnShares: earn shares
  earnSharesDesc: Join dFans and build the future with us.
  exclusiveContent: exclusive content
  fans: fans
  firstName: First Name
  followedYourProfile: followed your profile
  forThis: for this
  getTheseBenefits: get these benefits
  guideDec1: Primary Balance = Your Total Income (Cleared + Pending)
  guideDec2: >-
    Pending Balance = Pending Income (Typically 7 days from payment to
    processing)
  guideDec3: >-
    Income in Pending will not appear on your wallet page and cannot be
    withdrawn temporarily.
  hasBeenTransferredSuccessfully: has been transferred successfully! Enjoy!
  includingsfees: includings fees
  kodeDesc1: 'dFans partners with a trusted provider '
  kodeDesc2: >-
    to facilitate crypto deposits via credit card, ensuring user privacy and
    secure transfers to the creator.
  lastName: Last Name
  like: like
  likes: likes
  likessTip: Show post likes
  loginDesc: Please enter your details to log in.
  medias: media
  message: message
  minimumAmount: The minimum transaction amount is USD {price}.
  mintSuccess: Successfully unlocked exclusive content
  moonpayDec: >-
    When making your purchase, please select <span class="text-darkBrandYellow
    dark:text-brandYellow">"Ethereum (Arbitum)"</span> for the currency.
  moreThanDays: >-
    Posts older than 15 days cannot have their subscription plans, collections,
    and other settings changed.
  paidYou: paid you
  payMinAmount: >-
    The minimum transaction amount is {currency} {amount}, and the balance will
    be deposited into your wallet account.
  paymentTips: 'Tips: This wallet only supports transactions on the Arbitrum chain.'
  post: post
  purchasedInfo: Message fans who purchased this message
  purchasedYourCollection: purchased your collection
  referralReward: a referral reward
  requiredTip: >-
    Your subscription renewal failed due to a payment issue. Renew your
    subscription now to maintain access.
  rewardDec: Minimum $5
  serviceWalletDec1: 'Your collection or PPV content is sold '
  serviceWalletDec2: Fans subscribe to your profile
  serviceWalletDec3: Fans send you tips
  serviceWalletDec4: >-
    If a creator earns income in USD, dFans will convert it to USDT for the
    creator to withdraw after the payment partner Stripe processes and transfers
    the funds, which takes about 7 working days.
  serviceWalletTitle: 'The service wallet is used to receive crypto payments (ETH) when:'
  share: share
  shareDesc: Stake dFans shares to earn everyday dividends | Reference APR 2.88%
  shareprice: share price
  shares: shares
  shotBy: Shot by
  signinDesc: >-
    By signing up you agree to our Terms of Service and Privacy Policy, and
    confirm that you are at least 18 years old.
  socialStatusDown: social status down!
  socialStatusUp: social status up!
  sold: sold
  subscribeInfoDec: >-
    Please be aware that this subscribe DOES NOT include access to any media
    content.
  subscriptionFailedDec: >-
    Your subscription renewal failed. Renew your subscription now to maintain
    access.
  subscriptionPlan: You can access all content in this subscription plan.
  subscriptionRestarted: restarted the monthly subscription to your
  subscriptionSettingDec: You can create maximum 5 subscription plans for your fans.
  theContentHasBeenDeleted: the content has been deleted
  to: to
  toEarn: to earn
  totalFor: total for
  transactions: Transactions
  transactionsDetails: transactions details
  usernameProfile: Username (Profile)
  users: users
  veDFSAmount: veShare amount
  walletDec: >-
    Take note to top up USDT&Ether on <span class="ml-1
    typeface-robotoMedium">Arbitrum</span>.
  withYourFans: with your fans
  yourname: yourname
January: January
July: July
June: June
KYC:
  ApplyComplete: >-
    Your fiat payment application is pending. To activate it, please <span
    class="completeKYCVerification cursor-pointer textHover text-darkBrandYellow
    dark:text-brandYellow">complete KYC verification</span> now.
  ApplyFail: >-
    Your KYC submission did not meet our requirements. As a result, fiat payment
    services remain unavailable for your account.
  BackDriverLicenseCaptureTip: >-
    Please show the back side of driving licence in the marked area and press
    the button "Capture".
  BackIDCaptureTip: >-
    Please show the back side of your ID card in the marked area and press the
    button "Capture".
  BadLighting: Bad lighting
  BlurryOReflections: Blurry or reflections
  ByClicking: 'By clicking “I agree” you understand and agree that:'
  ByClickingDesc1: 'You consent to the collection to verify your age and identity. '
  ByClickingDesc2: 'You are at least 18 years of age. '
  ByClickingDesc3: 'The personal data you will provide is accurate, genuine and valid. '
  ByClickingDesc4: You have read and understood the information contained in this notice.
  Capture: Capture
  CaptureBackDriverLicense: Please capture the back of driver's licence
  CaptureBackFace: Capture back page
  CaptureBackIdentityCard: Please capture the back of identity card
  CaptureDriverLicenseDocument: Capture driver license document
  CaptureFrontDriverLicense: Please capture the front of driver's licence
  CaptureFrontFace: Capture front page
  CaptureFrontIdentityCard: Please capture the front of identity card
  CaptureIdentificationDocument: Capture identification document
  CaptureMainPage: Capture main page
  CapturePassport: Please capture the main passport page
  CapturePassportDocument: Capture passport document
  CaptureYourFace: Capture your face
  CheckImage: Check the captured image quality
  ClickHere: Click here
  Confirm: Confirm
  ConfirmYourIdentityVerification: Confirm your identity verification
  ContactUs: Contact us
  Continue: CONTINUE
  Copied: LINK COPIED
  DidNotWork: Did not work?
  DontWorry: Don't worry.
  DriverLicence: Driver Licence
  EmailLinkRedirect: >-
    Please enter your email address to receive a URL that will redirect the
    process to your mobile phone.
  EmailSentSuccessfully: Email sent successfully
  EnterEmail: Enter your email address
  EnterLinkIntoBrowser: Enter this link into your mobile phone's browser
  EnterLinkMan: Try again by entering the link manually.
  EnterUrlIntoBrowser: >-
    If the other methods did not work, please enter this URL into your phone's
    browser.
  ExitConfirm: Are you sure you want to quit identity verification?
  ExitConfirmDesc: All the progress you made in the identity verification process will be lost.
  FrontDriverLicenseCaptureTip: >-
    Please show the front side of driving licence in the marked area and press
    the button "Capture".
  FrontIDCaptureTip: >-
    Please show the front side of your ID card in the marked area and press the
    button "Capture".
  GoBack: Go Back
  GoHome: Go Home
  IdentityCard: Identity Card
  IdentityVerification: Identity Verification
  KYCVerify: >-
    We are currently reviewing your submitted verification documents. The
    process may take up to 2 days to finalize.
  MainMistakes: Main mistakes
  NotFace: Not a neutral face
  NotRecvEmail: Didn't receive the email?
  Overview: Overview
  OverviewDesc1: >-
    dFans respect your privacy and we are committed to protecting the personal
    data we process about you.
  OverviewDesc2: >-
    All users of our website must be at least 18 years of age. Before you can
    start a Creator account, we need to verify your age and identity.
  OverviewDesc3: >-
    We may also require you to periodically authenticate your identity during
    the time that you hold an account with us, to confirm that you are the
    account holder.
  Passport: Passport
  PassportBackCapture: Please capture the back of identity card
  PassportCaptureTip: >-
    Please show the main document page that contains MRz zone in the marked area
    and press the button "Capture".
  PassportFrontCapture: Please capture the front of identity card
  PleaseContinueProcessMobile: >-
    Please continue the process on the mobile phone by scanning QR code or
    copying the link. Using your phone speeds up and simplifies the verification
    process.
  PleaseSelectCountry: Please select country first
  PleaseVerifity: >-
    We are unable to verify your account at this time. Please click "verify
    account” and follow the instructions. Thanks
  PositionYourFaceDesc: Position your face in the middle of the frame.
  PostionDoc: Position the document inside the frame.
  Process: Process
  ProcessDesc1: >-
    Choose and capture a document, such as passport, identity card, or driver
    license Take a selfieChoose and capture a document, such as passport,
    identity card, or driver license
  ProcessDesc2: Take a selfie
  ReLogin: Re-login
  RecommendMobileDevice: >-
    We recommend using mobile device or device with camera to complete this
    verification step
  Reviewing: Reviewing
  ReviewingDesc: Your submitted documents are currently under review. Please wait a moment.
  ScanQrcode: Scan QR code
  ScanQrcodeDesc: Or enter this link into your mobile phone's browser
  SelfieTip: >-
    Position your face in the middle of the frame and follow the instructions.
    Photo should be not blurry and evenly lit.
  SendLink: Let us send you the link
  StartIdentityVerification: Start identity verification on your mobile phone
  Step1: Choose document
  Step2: Capture document
  Step3: Take selfie
  Step4: Confirmation
  SubmitKycInfo: >-
    Your KYC is under review (est. 3 days). We’ll notify you when approved.
    Thanks!
  SurePhotoQuality: >-
    Make sure that the photo is clearly visible. If you believe, that the image
    quality is acceptable, please check the "Confirm" button.
  SureSelfieQuality: >-
    Make sure that the photo is clearly visible. If you believe, that the image
    quality is acceptable, please check the "Confirm" button.
  SwitchAccount: Switch Account
  SwitchAccountTip: >-
    You need to log in with the correct account to proceed with the
    verification. Please switch account.
  TakeSelfie: Take a selfie
  Thx: We're reviewing your documents
  TooBlurry: Too Blurry
  TooDark: Too dark
  TooSmall: Too small
  TryAgain: TRY AGAIN
  TryAnotherMethod: Doesn't work? Try another method
  ValidateEmailMsg: Please enter a valid email address
  VerificationCompleted: >-
    This may take up to 2 days, so feel free to continue using dFans. We'll
    notify you when the review is finished.
  VerificationFailed: >-
    Your KYC verification was unsuccessful. If you need assistance, feel free to
    contact our support team.
  VerificationSuccess: Your account has been successfully verified.
  VerifyAccount: Verify Account
  VerifyFail: 'Your account verification was unsuccessful. Please verify account again. '
  VerifySuccess: Your account has been successfully verified.
  WantDiffDoc: Want to select different document?
  chooseDocument: Choose a document and start verification
  footerDesc: If you have trouble with your camera or the verification process?
  footerDesc2: Feel free to contact our support team — we’re here to help.
  footerDesc3: >-
    💡 You can also continue accessing your profile to complete and update your
    information.
  verificationSuccess: Your verification is complete. Fiat payments are now enabled.
Label:
  AccountHolderName: Account holder name
  AccountNumber: Account number
  Amount: Amount
  BSB: BSB(Bank Service Branch code)
  BankAccount: Bank account
  BankCountryRegion: Bank country / Region
  ChooseAudience: Choose audience
  ConfirmAccountNumber: Confirm account number
  Currency: Currency
  DisplayName: Display name
  Headline: Headline
  IBAN: IBAN
  ListName: List name
  Location: Location
  MaxWithdrawable: Max Withdrawable (with Loan)
  MessageContent: Message content
  Nickname: Nickname
  Note: Note
  Price: Price
  RoutingNumber: Routing number
  Title: Title
  WithdrawableCash: Withdrawable Cash
  WithdrawalInformation: Withdrawal information
Lable:
  1year: 1 year
  2year: 2 year
  3Months: 3 months
  3year: 3 year
  6Months: 6 months
Language:
  Arabic: Arabic
  ChineseSimplified: Chinese simplified
  ChineseTraditional: Chinese traditional
  English: English
  France: France
  Germany: Germany
  Greece: Greece
  Hungary: Hungary
  India: India
  Italy: Italy
  Japanese: Japanese
  Korean: Korean
  Poland: Poland
  Portuguese: Portuguese
  Russian: Russian
  Spanish: Spanish
  Turkish: Turkish
  Ukrainian: Ukrainian
Last30Days: Last 30 days
Last30DaysRecords: Only records from the last 30 days are shown.
LinkTelegramDesc: >-
  Link your telegram with our bot to receive instant updates on payments and
  messages from your fans.
Local:
  Benefit1: Unlock exclusive content under this subscription
  Benefit2: Cancel anytime with no restrictions
  Benefit3: Auto-renew every 30 days
  Benefit4: Billing begins after the free trial ends
  BenefitTitle: SUBSCRIBE AND GET THESE BENEFITS
LocalTime: local time
Login:
  JoinDesc1: Frustrated with support? DM dFans anytime for help.
  JoinDesc2: Access a dedicated helpdesk with articles and videos.
  JoinDesc3: Get essential marketing tips for your personal page.
  JoinDesc4: Connect with like-minded creators for collaboration.
  JoinTitle1: 24/7 Support
  JoinTitle2: Help Center
  JoinTitle3: Blog
  JoinTitle4: Community
ManualPayouts: Manual payouts
March: March
May: May
Menu:
  BecomeCreatorIntro: Become a creator
  Collections: Collections
  CreatePost: Post
  Creators: My Page
  EditProfile: Settings
  FAQ: Help and support
  Feedback: Feedback
  Home: Home
  Logout: Log out
  More: More
  Notifications: Notifications
  Payments: My Payments
  Queue: Queue
  RewardCenter: Referrals
  Settings: Settings
  Shares: Shares
  Statistic: Statistic
  Subscriptions: Subscriptions
  Vault: Vault
  Wallet: My Wallet
  messageBoard: Messages
Message:
  BindEmailSuccess: Bind email successfully!
  BuySuccess: payment successful
  BuySuccessFully: Buy SuccessFully!
  CVCInvalid: cvc invalid
  Cancelled: Cancelled successfully!
  ChooseCountry: Please choose Country / Region
  ChoosePrice: Please choose price first
  ClaimSuccessfull: Claim successfully!
  ComingSoon: Coming soon
  ConnectedError: Connected failed. Please try again.
  ConnectedSuccessfully: Connected successfully!
  Copied: Copied to clipboard!
  CopiedPostLink: Link to post has been copied to clipboard!
  CopySuccess: copy successfully!
  DeleteSuccess: Delete successfully!
  DeleteSuccessfull: Delete successfully
  DeleteUserSuccess: Delete account successfully!
  EmailExistWarn: This email is already registered with dFans
  EmailSentSuccessfully: Email sent successfully
  EnterAccountHolderName: Please enter account holder name
  EnterAccountNumber: Please enter account number
  EnterAddressZip: Enter postal code
  EnterBSB: Please enter BSB
  EnterBenefit: Please enter benefit first
  EnterCurrency: Please choose currency
  EnterFullNameOnCard: Enter full name on card
  EnterIBAN: Please enter IBAN
  EnterMessageContent: Please enter the message content
  EnterPrice: Please enter price
  EnterRoutingNumber: Please enter routing number
  EnterSameAccountNumber: Please enter the same account number
  EnterTitle: Please enter title
  ExpiryDateExpired: The card has expired.
  FileOver2048: The file size exceeds 10GB
  FileOver5MB: The file size exceeds 5MB
  FileSizeOver10: The file size exceeds 10MB
  FileTypeError: Filetype not allowed
  InvalidCardLength: >-
    The length of the card number does not meet the requirements of the card
    issuer.
  InvalidCardNumber: Card number verification failed, please enter a valid card number.
  InvalidCardNumberFormat: The card number must be 13-19 digits.
  InvalidCollectionName: 'Collection title supports only these symbols  : _ - . ! , | /'
  InvalidExpiryFormat: The validity format should be MM/YY
  InvalidExpiryMonth: The month must be from 01 to 12
  LeavePageContent: Does the current content need to be saved as a draft?
  Maintenance: The system is currently being upgraded. Please try again later.
  MessageDisable: Message could not been sent at this time
  MessageDisabled: The welcome message has been successfully disabled.
  MessageNotBlank: Your message cannot be blank
  MonthlyPrice: Please input monthly price
  NetworkError: Network Error
  OnlySupportImageAndVideo: Only support image or video
  PasswordChangedSuccessfulL: Password changed successfully!
  PaymentWalletAddedSuccessfully: Payment wallet added successfully.
  PleaseBanner: Please upload collection banner
  PleaseChooseOneCreditCard: Please choose one credit card
  PleaseCollectionName: Titles must begin with a letter
  PleaseEnterAddress: Please enter address
  PleaseEnterBankAccountNumber: Please enter bank account number
  PleaseEnterCVC: Please enter cvc
  PleaseEnterCardNumber: Please enter card number
  PleaseEnterContent: Please enter content or upload media file first!
  PleaseEnterExpiryDate: Please enter expiry date
  PleaseEnterFirstName: Please enter first name
  PleaseEnterLastName: Please enter last name
  PleaseEnterLegalBusinessName: Please enter legal business name
  PleaseEnterTheAmount: Please enter the amount
  PleasePrice: Please enter price
  PleaseSelectCategory: Please select one category first.
  PleaseSelectCity: Please select city
  PleaseSelectCountry: Please select country or region
  PleaseSelectCurrency: Please select currency
  PleaseSelectState: Please select state
  PleaseSelectUser: Please select user
  PostedSuccessfully: Posted successfully.
  PriceRange: Maximum subscription price is $200.
  PromotionStopped: Promotion Stopped
  SaveSuccess: Save successfully
  SavedSuccessfully: Save draft successfully
  SelectAudience: Please select audience
  SelectBankAccount: Please select bank account
  SendError: Send Error
  SendSuccess: Send Success!
  SendSuccessfully: Send successfully!
  Sending: Sending...
  SubmitError: Submit error!
  SubmitSuccessfull: Submit Successfully!
  SubscriptionDeleted: This Subscription tier has been deleted.
  Success: Success!
  SuccessSubmit: >-
    Your request has been successfully submitted! We will proceed within 48
    hours.
  ThisCommentHasBeenDeleted: This comment has been deleted.
  TierName: Please input tier name
  TransferSuccess: Transfer successfully!
  UnlockSuccessfully: Unlock Successfully!
  Unsend: Are you sure you want to unsend this message?
  UnsupportedCardType: Unsupported card types
  Update Successfull: Update Successfully!
  UploadPictureVideo: Please upload pictures or video
  WithdrawalSuccess: Withdrawal success!
  WithoutSave: Are you sure you want to exit without saving?
  categoryName: Please input category name
  confirmAccountNumber: Please enter confirm account number
  subscriptionDuplicated: The subscription price cannot be duplicated.
  switchedAccount: You have switched your account.
  withdrawalError: >-
    Your payout request is currently unable to be processed. Please try again
    later.
MessageMedia: Message
Network: Network
NetworkFee: Network fee
NewUserMessage:
  WelcomeToDFans: >-
    Hi! Glad to see you here. I hope you will enjoy watching my photos and
    videos. And if you want more, you can order custom videos and photos from me
  dec1: >-
    This is a decentralized social platform where user privacy is our top
    priority!
  dec2: Fans are free to consume, and creators are free to create!
  dec3: >-
    No unjustified bans, no constraints on payouts; what’s yours will always
    remain yours! Decentralization is not just a concept—it's a spirit, a
    belief!
  dec6: Cheers, friends!
  dec7: The dFans Team
Notifications:
  ApplicationBeApproved: >-
    Your application has been approved! Congratulations on joining dFans. Your
    page is
  RenewSubscriptionNotification1: Your subscription to
  RenewSubscriptionNotification2: failed to renew.
  RenewSubscriptionNotification3: Resume subscription
  SetUpYourSubscription: "Set\_up\_your subscription\_now!"
  YourFiatPayoutRequestHasBeenApproved: Your fiat payout request has been approved.
  YourFiatPayoutRequestIsCurrentlyOnHold: Your fiat payout request is currently on hold.
November: November
October: October
OnArb: 'on'
Open: Open
Partner:
  OurPartners: Our Partners
  OurPartnersDesc: INDUSTRY LEADERS FROM
PayOutFunds: PAY OUT FUNDS
PayWay:
  AmericanExpress: american express
  DinersClub: Diners Club
  Discover: Discover
  JCB: JCB
  Mastercard: mastercard
  UnionPay: UnionPay
  Unknown: Unknown
  Visa: Visa
PaymentAmount: Payment amount
PaymentDate: Payment date
PaymentFailed: >-
  The transaction was declined by the issuing bank.Please try another credit
  card.
PaymentForCollectionFrom: Payment for collection from
PaymentForMessageFrom: Payment for message from
PaymentForSubscriptionFrom: Payment for subscription from
PaymentType:
  All: All
  Collection: Paid Collection
  MessageMedia: Message
  PPV: PPV
  Post: Post
  Reward: Tips
  Subscription: Subscription
PaymentsForPostFrom: Payments for post from
PayoutAmount: Payout amount
PayoutBalance: Payout balance
PayoutCompleted: Payout completed
PayoutFrom: Payout from
PayoutTo: Payout to
Payouts: Payouts
PendingPaymentDesc: Processing now – it may take 7 or more business days
Placeholder:
  AccountHolderName: Account holder name
  AccountNumber: Account number
  AddDescription: (Optional) Add description
  AddPeople: Add people
  AiChatsDefinition: What's your Character's backstory? How do you want it to talk or act?
  AiChatsDescription: How would your Character describe themselves?
  AiChatsName: How would you like your fans to address you?
  AiChatsTagline: Add a short tagline of your Character
  BSB: BSB(Bank Service Branch code)
  CategoryName: Category name
  CollectionPrice: Collection price
  CollectionTitle: Collection title
  ConfirmAccountNumber: Confirm account number
  ConfirmNewPassword: Confirm new password
  CountryRegion: Country / Region
  CurrentEmail: Current email
  CurrentPassword: Current password
  Description: Description
  E-mail: E-mail
  Email: Email
  Enter: Enter
  EnterLocation: Enter your Location
  EnterMessage: Enter your message
  EnterName: Enter a name
  EnterNote: Please enter Note
  EnterOnlyfans: Enter your other fansite page link
  EnterVerificationCode: Enter verification code
  EnterWithdrawalAmount: Please enter withdrawal amount
  EnterYourEmail: Enter your email
  EnterYourName: Enter your Name
  EntergumroadPageLink: Enter your info
  FirstName: First name
  FullNameOnCard: Full name on card
  IBAN: IBAN
  InvitationCode: Optional if available
  LastName: Last name
  Minimum: Minimum 0.0001
  MonthlyPrice: Price per month
  Name: Name
  NewMessage: Here’s a new message just for you ;)
  NewPassword: New password
  Password: Password
  PleaseSelect: Please select
  PostalCode: Postal code
  ReasonsRequired: The issue field is required
  RoutingNumber: Routing number
  Search: Search
  SearchCreators: Search creators
  Select: Select
  SelectCard: Select card
  SelectFromAvailableOptions: Select from available options
  SelectSubject: Select subject
  SelectYourContentCategory: Select your content category
  TellUs: Tell us about yourself ...
  ThankYouMessage: e.g. Thank You Message
  Title: Title
  TrySearchingForMedia: Try searching for media
  TypeAMessageHere: Type a message here...
  UploadContractBanner: Upload collection banner
  Username: Username
  VerificationCode: Verification code
  WalletAddress: Wallet address
  someReasons: some reasons...
  someReasonsMin: Enter at least 5 characters
PlatformFee: Platform fee
PlayVideo: Play video
PleaseBindEmail: Please bind email first.
PleaseEnterCode: Please enter code
Post:
  AddAudio: Add audio
  AddCalendar: Add calendar
  AddImage: Add image
  AddMediaFromVault: Add media from vault
  AddPlay: Add to playlist
  AddVideo: Add video
  CREATORS: CREATORS
  DeletePost: Delete post
  DownloadVideosImages: Download Videos & Images
  Emoji: Emoji
  Light: Light
  MEDIA: MEDIA
  Medium: Medium
  'Off': 'Off'
  POSTS1: POSTS
  Pause: Pause
  Play: Play
  PostPrice: Post price
  Posts: Posts
  PriceToView: Price to view
  PublishNow: Publish now
  RECENT: RECENT
  Scheduledfor: Scheduled for
  SensitiveContent: Sensitive Content
  SensitiveContentDec1: 'This content may be sentitive to some users. '
  SensitiveContentDec2: You must be 18 or older to view this content.
  SensitiveContentFilter: Sensitive Content Filter
  SensitiveDec1: >-
    Configures the amount of blur on sensitive content when you browse dFans.
    This only affects what you see and does not affect the content you upload.
  SensitiveDec2: >-
    Enabling the sensitive content filter will also show less NSFW content in
    the FYP.
  SensitiveDec3: You can configure the filter under
  SensitiveDec4: Settings -> Privacy & Safety
  SensitiveDec5: at any time.
  Strong: Strong
  UnlockNow: Unlock this Media
  UnlockToPlay: Unlock to Play
  View: View
PrimaryCard: Primary
RECENT: RECENT
Referrals: Referrals
RefundedPaymentDesc2: Refunded by the payment processor.
Report:
  desc1: I don’t like this post
  desc2: Violates dFans Terms of Service
  desc3: Contains copyrighted material (DMCA)
  desc4: Child Sexual Abuse Material (CSAM)
  desc5: Report Spam
  desc6: Report Abuse
Result: Result
RiskEarningItem: >-
  The payment has been flagged as a risk by the payment processor. Please allow
  at least 15 days for a review to be completed.
RiskyAccountDesc: The account is risky, you need to contact support. Thank you.
Rules:
  EmailIsAlreadyRegistered: This email is already registered with Dfans
  EmailIsNotVerified: E-mail {email} is not verified
  EmailRequired: E-mail is required
  EnterDisplayName: Please enter display name
  EnterLabelName: Please enter label name
  EnterValidEmail: Please enter a valid email
  NameRequired: The Name field is required
  PasswordField6Characters: The Password field must be at least 6 characters
  PasswordRequired: The Password field is required
  PasswordsDoNotMatch: Passwords do not match.
  VerificationCodeRequired: Verification code is required
  WalletAddressRequired: Wallet address is required
  WrongEmailOrPassword: Wrong email or password
  WrongPasswordRule: >-
    Password must be at least 6 characters, must contain at least 1 number, 1
    lower case latin letter, 1 upper case latin letter
ScanBotLink: Please scan the code or use the link to connect our bot.
SearchCreators: Search for creators on dFans
SearchNothingFound: Nothing found
SearchUsersPost: Search user's post
SecurityCheck: Security check
SendCodeToEmail: Send code to email
SendSuccess: Send success
September: September
SetAsPrimary: Set as Primary
StartDate: Start Date
Status: {}
Subscribe:
  Active: Active
  AddSubscriptionBundle: Add subscription bundle
  CampaignStartedSuccessfully: Campaign Started Successfully
  CancelSubscription: Are you sure you want to cancel your subscription?
  ClaimsCount: Claims count
  Decsription: Promotional subscription $0.00 USD for {freeTrialDay} days.
  Decsription1: User will not be subscribed for ${amount} automatically, only by choice.
  Decsription2: Promotional subscription ${amount} USD per month
  Decsription3: Minimum payment is $3.
  DiscountPercent: Discount percent
  DiscountRate: Discount rate
  Duration: Duration
  ExpiredSubscribers: Expired subscribers
  FirstMonthDiscount: First month discount
  FreeTrial: Free trial
  FreeTrialDuration: Free trial duration
  IncrementalAndExpiredSubscribers: Both new and expired subscribers
  IncrementalSubscribers: New subscribers
  LimitedOffer: Limited offer
  MessageOptional: Message (optional)
  Months: Months
  OfferEnds: Offer ends
  OfferExpiration: Offer expiration
  OfferLimit: Offer limit
  PRROMOTIONCAMPAIGN: PRROMOTION CAMPAIGN
  PromotionCampaignFor: Promotion campaign for
  SUBSCRIBED: SUBSCRIBED
  Started: Started
  Subscribe: Subscribe
  SubscribeEth: Subscribe with ETH
  SubscribeNow: Subscribe now
  SubscribeSOL: 'Subscribe with '
  SubscribeUSDC: Subscribe with USDC
  SubscribeUSDT: Subscribe with USDT
  SubscribedPlans: Subscribed plans
  Subscription: SUBSCRIPTION
  SubscriptionUpgrade: Subscription Upgrade
  TierBenefits: TIER BENEFITS
  Unsubscribe: Unsubscribe?
  addBundleDecs: ' Subscription for {durationMonth} months for ${discountPrice} total.'
  buyDec: >-
    Verifying the subscription status on the blockchain. Please await
    confirmation for a few moments.
  days: days
  discount: discount
  discountOptions: discount options
  lastSubscription: Last subscription
  lastSubscriptionDate: last subscription date
  'off': 'off'
  offersLeft: offers left
  promotionDec: You need to create a subscription prior to start a promotion campaign
  subscribe: Subscribe
  subscribePrice: subscription price
  subscribers: subscribers
  subscriptionDays: subscription days
  suspended: Stopped
Subscribers: Subscribers
SubscribersCount: Subscribers count
Suggestions: SUGGESTIONS
SwitchCreator: Switch to Creator
SwitchFans: Switch to Fans
TableTitle:
  CreatorInfo: Creator info
  Date: Date
  ETHEarn: ETH Earn
  From: From
  InvitationDate: Invitation Date
  Invitee: Invitee
  Invitees: Invitees
  ItemUper: Item
  Type: Type
  USDTEarn: USDT Earn
  UsersInfo: Users info
  YourEarn: Your Earn
  YourEarnInUSD: Your Earn in USD
Telegram:
  FollowX: Follow us on X
  InviteFriends: Invite friends
  RepostX: Repost dFans.xyz on X
  desc1: >-
    dFans is a decentralized 18+ subscription platform for Generations X, Y, and
    Z, free from overbearing censorship.
  desc2: No overbearing KYC procedures
  desc3: No limits, No high fees
  rewardsDesc: Stake dFans shares to earn everyday dividends
TelegramBot: Telegram bot
TipsFrom: Tips from
Title:
  80-20Split: 85-15 Dynamic Split
  AddNewPayoutWallet: Add new payout wallet
  BecomingCreatorFAQ: Frequently Asked Questions for Creators
  ClaimStakingDividends: Claim staking dividends
  CommissionCashback: Unbelievable Withdrawal Fee
  CryptocurrencySafe: What if USDT isn’t supported in some regions？
  DFansCampaigns: 'dFans Campaigns: How to Market Like a Pro'
  DFansCampaignsExplained: dFans Campaigns, Explained
  DailyStakingRewards: >-
    The daily staking rewards for each user can be calculated using the
    following formula
  FAQ10: How long does it take to become a creator?
  FAQ6: Is it safe to withdraw using cryptocurrency?
  FAQ7: What is dFans?
  FAQ8: Who can create on dFans？
  FAQ9: Is dFans completely KYC-free?
  FollowersSubscribers: Your Earnings Start Here
  FreeOpen: No Unjust Censorship
  HowFrequent: Can I withdraw in USD?
  HowMuchMoney: How much money will I earn with dFans?
  HowShareholders: How do shareholders realize profits?
  PayoutWallet: Payout Wallet
  PlatformBuybacks: Platform Buybacks
  PostAnyContent: What is dFans’ payout cycle?
  QuickEarningsAccess: Built-in AI Closer
  ReferralBonuses: AI Chatter
  ReferralsEarnings: 5% of your referrals’ earnings
  Rewards: Rewards
  Schedule: Schedule
  SecondConfirmation: Second Confirmation
  SettingUpYourNewCampaign: Setting Up Your New Campaign
  StakeShares: Stake Shares
  Staking: Staking
  StakingYields: Staking Yields
  Two-weekTrialPeriodEnds: Two-week trial period ends
  Vault: Vault
  WHY_DECENTRALIZE: Why decentralize?
  WhatIsDFS: What is DFS?
  WhatPaymentMethods: What payment methods are used for payouts?
  YourOwnEarnings: 1% of your own earnings
TopCreators: Top Creators
TopUp: Top-up
TrackingLinkCreated: Tracking link created
TransStatus: Status
TransactionHash: Transaction hash
TrySearching: Try searching for creators
TrySearchingPost: Try searching for user's post
USDCBalance: USDC Balance
USDTBalance: USDT Balance
USDTWithDrawTips: >-
  The minimum transaction amount is 3 {currency} (including 1 {currency} network
  fee).
UnknownUser: Unknown user
UploadVideoFail: Upload video failed, please try again
UsdBalance: USD Balance
UsdPayments: USD Payments
UsdcBalance: USDC Balance
UsdtBalance: USDT Balance
UsdtPayments: USDT Payments
User:
  Collectors: Collectors
  ContentProviderAgreement: Content Provider Agreement
  ContentProviderAgreement2: >-
    I acknowledge and agree that my images will be used and displayed publicly
    on the website
  Country: Country
  CountryRegion: Country / Region
  CreationPlanDesc: Choose the right industry for more exposure.
  DeleteAccount: Delete account
  ENTER_YOUR_INFO: ENTER YOUR INFO
  Email: Email
  EnterSubject: Enter subject
  EnterYourInfoDesc: >-
    Upon approval, your details will be automatically updated as your page
    information.
  Follow: Follow
  Followers: Followers
  Following: Following
  FullName: Full name
  IdentityDocumentCheck: Identity Document Check
  IdentityDocumentCheckDesc: >-
    Please ensure that neither your face nor any other information on the
    document has any reflections.
  InvitationCode: Invitation Code
  Name: Name
  OnlyfansUsername: Your other fansite page link (optional）
  Password: Password
  SelfieCheck: Selfie - Liveness Check
  SelfieCheckDesc: >-
    Please make sure there are no pictures behind you or anything that might
    obstruct the verification of your picture.
  ShowFansWhereYourePopular: 'Show fans where you''re popular:'
  TotalVolume: Total volume
  Unfollow: Unfollow
  VerifyAccount: Verify account
  WhatDoYouPlanOnCreating: What do you plan on creating?
  YourSocialMedia: Your Social Media
  verified: verified
  verifyIdentity: Verify your identity and ensure you are 18 years or older
ViewTransactionInfo: View transaction info
WalletBalance: WALLET BALANCE
WhereFindDfans: Where did you find dFans.xyz?
WithdrawAmount: Withdraw Amount
Withdrawable: Withdrawable
WithdrawableSoon: Withdrawable soon
WithdrawalAmount: Withdrawal amount
WithdrawalProcessed: Your withdrawal request is currently being processed.
WithdrawalVideo:
  title11: 'How to: swap USDT to ETH with metamask'
YouWIllBeCharge: You will be charged {0}
appUpdate:
  later: Later
  newVersion: New Version Available
  updateNow: Update Now
  updatePrompt: Please update to get the latest features and fixes
  viewChanges: View Changes
creatorapply:
  dec1: >-
    Quick setup, post freely. We safeguard your freedom and avoid unnecessary
    content censorship.
  dec2: >-
    No minimum withdrawals, no payout delays. Creators receive their deserved
    income instantly.
  dec3: >-
    Help creators monitor traffic conversion from various channels to better
    acquire paying users.
  title1: More Open and Free
  title2: Quick Payout Access
  title3: Powerful Analytics
dropdownMenu:
  AddFunds: Add Funds to Your Wallet
  BecomeCreator: Become a creator
  BecomeCreatorIntro: |-
    <div class="flex items-center">
          <div class="mr-0.5 typeface-robotoRegular text-sm">Become a creator</div>
          <div class="typeface-robotoRegular text-xs text-white text-opacity-60">(to earn)</div>
        </div>
  Collections: Collections
  Creators: My Profile
  Deposit: Deposit on chain
  EditProfile: Setting
  FAQ: Help and Support
  Feedback: Feedback
  Logout: Logout
  Payments: My Payments
  Profile: Profile
  Queue: Queue
  Referrals: Referrals
  RewardCenter: Recruit award
  SignUp: Sign up
  Subscriptions: Subscriptions
  Trending: Trending
  Vault: Vault
  WalletBalance: Wallet Balance
hobbies:
  baking: baking
  calligraphy: calligraphy
  chess: chess
  composing_music: composing music
  cooking: cooking
  crafting: crafting
  cycling: cycling
  drawing: drawing
  fishing: fishing
  gardening: gardening
  hiking: hiking
  listening_to_music: listening to music
  painting: painting
  photography: photography
  playing_the_guitar: playing the guitar
  playing_the_piano: playing the piano
  reading: reading
  running: running
  singing: singing
  solving_puzzles: solving puzzles
  swimming: swimming
  traveling: traveling
  writing: writing
  yoga: yoga
kyc:
  notFound: Parameter error
login:
  FeaturedIn: 'Featured in:'
  about: About dFans
  easyCryptoEarnings: The Decentralized Creator's Platform
  easyCryptoEarningsDesc: >-
    Easy crypto earnings start here. Fast payouts. No limits. Built for the
    future.
  freeAndLessThanAMinute: It’s free and takes less than a minute!
  lovedByCreators: Loved by 100,000+ Creators
  postDesc1: >-
    dfans is a decentralized subscription platform for Generations X, Y, and Z,
    free from overbearing censorship.
  postDesc2: >-
    Creators can accept any currency from fans, and dfans will convert these
    into USDT for the creators, avoiding Limits and delays.
  postDesc3: >-
    Put your exclusive content behind a paywall for your top fans to subscribe
    to, generating you recurring revenue.
  postDesc4: >-
    Not only can you set up Pay-to-view for individual Posts, but you can also
    create Collections for Pay-to-views.
  postDesc5: >-
    Powerful messaging features let you connect with your fans and enable direct
    payments through messages.
  postDesc6: >-
    Block regions you prefer to exclude, enhancing privacy and security for
    every creator.
  postDesc7: >-
    Talk Like a Human. Sell Like a Pro.Helps you craft better replies, chat
    faster, save time — and boost your earnings.
  postDesc8: >-
    dfans is made for a generation that values freedom, privacy, and real fan
    connection — no forms, no friction, just you and your tribe.
  postTitle1: No overbearing KYC procedures
  postTitle2: USDT Payout, No Limits, No High Fees
  postTitle3: Earn money from subscriptions
  postTitle4: Sell content with collection pay-to-view
  postTitle5: Connect with your fans with messaging
  postTitle6: Customize Geo-Blocking to your preferences
  postTitle7: Built-in AI Closer
  postTitle8: No forms. No waiting. Just freedom.
  subtitle: people joined today!
  title: Join dFans - No overbearing KYC procedures
payments: Payments
placeholder:
  EnterUserName: Enter user name
  EnterWebsiteUrl: Enter website URL
route:
  ACCOUNT: ACCOUNT
  ACTIVE_DROPS: ACTIVE DROPS
  ADD_BANK_ACCOUNT: ADD BANK ACCOUNT
  AIChatbotSettings: AIChatbotSettings
  AIchatbotsettings: AI chatbot settings
  Account: Account
  Addbankaccount: Add bank account
  BECOME_A_CREATOR: BECOME A CREATOR
  BecomeCreator: Become a Creator
  CLAIM_STAKING_DIVIDENDS: CLAIM STAKING DIVIDENDS
  COLLECTIONS: COLLECTIONS
  CREATECOLLECTION: CREATE COLLECTION
  CREATORDASHBOARD: CREATOR DASHBOARD
  Campaigns: Campaigns
  Chatup: MESSAGE
  Claimstakingdividends: Claim staking dividends
  Collections: Collections
  CreateCollection: Create Collection
  Creators: My page
  DECENTRALMYCOLLECTION: MY COLLECTION
  DECENTRALMYCOLLECTIONS: MY COLLECTION
  DFANS_SHAREHOLDER: DFANS SHAREHOLDER
  DFSRewardDividends: DFS Reward Dividends
  DFSStaking: DFS STAKING
  DFS_REWARD_DIVIDENDS: DFS REWARD DIVIDENDS
  DFS_STAKING: DFS STAKING
  DFansShareholder: DFANS SHAREHOLDER
  DecentralCreatePost: DecentralCreatePost
  DecentralMembers: Members
  DecentralMyCollection: My Collection
  DecentralPost: Posts
  DecentralProfile: Edit Profile
  DecentralWallet: My Wallet
  DecentralfansMessage: DecentralfansMessage
  DecentralfansNotification: DecentralfansNotification
  EDIT_COLLECTION: EDIT COLLECTION
  EDIT_PROFILE: EDIT PROFILE
  EDIT_TIER: EDIT TIER
  Earning: Earning
  EditProfile: Edit Profile
  EditProfileUpperCase: EDIT PROFILE
  Editcollection: Edit collection
  Editprofile: Edit profile
  Edittier: Edit tier
  FANCLUB: FANCLUB
  FAQ: FAQ
  Feedback: Feedback
  HOME: HOME
  HelpAndSupport: Help and Support
  Home: Home
  INVEST_IN_INFLUENCERS: INVEST IN INFLUENCERS
  Investmentsettings: Investment settings
  MARKETPLACE: MARKETPLACE
  MESSAGEBOARD: MESSAGES
  MESSAGEDETAIL: Messages
  MESSAGES: MESSAGES
  MY_PAYMENTS: MY PAYMENTS
  MY_POSTS: POSTS
  MY_WALLET: MY WALLET
  Marketplace: Marketplace
  More: More
  MyPosts: Posts
  Mycontracts: My Collection
  Mywallet: My wallet
  NOTICATIONS: NOTICATIONS
  NOTIFICATION: NOTIFICATION
  NOTIFICATIONS: NOTIFICATIONS
  Notification: Notification
  Notifications: Notifications
  PORTFOLIO: PORTFOLIO
  POST: POST
  PRESS_RELEASE: PRESS RELEASE
  PROFILE: PROFILE
  Payments: My Payments
  Portfolio: Portfolio
  Post: Post
  Profile: Profile
  Queue: Queue
  REFER_AND_EARN_MORE_MONEY: REFER AND EARN MORE MONEY
  REWARD_CENTER: REWARD CENTER
  ReadLess: Read less
  ReferandEarnMoreMoney: Refer and Earn More Money
  Referrals: Referrals
  RewardCenter: Referrals
  SECOND_CONFIRMATION: SECOND CONFIRMATION
  SHARES: SHARES
  SHARES_STAKING: SHARES STAKING
  SHARE_REWARDS_DIVIDENDS: SHARE REWARDS DIVIDENDS
  STAKE_DFS: STAKE SHARE
  SUBSCRIPTIONS: SUBSCRIPTIONS
  SUBSCRIPTION_TIERS: SUBSCRIPTION TIERS
  SecondConfirmation: Second Confirmation
  Settings: Settings
  ShareRewardsDividends: SHARE REWARDS DIVIDENDS
  Shares: Shares
  SharesStaking: SHARES STAKING
  StakeDFS: Stake Share
  Statistic: Statistics
  SubscriptionTiers: Subscription tiers
  Subscriptions: Subscriptions
  Subscriptiontiers: Subscription tiers
  SubscriptiontiersRoute: Subscription tiers
  TELL_MORE_PEOPLE: TELL MORE PEOPLE
  TRANSACTION: TRANSACTION
  TRENDING: TRENDING
  Tellmorepeople: Tell more people
  Transaction: Transaction
  TransactionDetails: TRANSACTION DETAILS
  Trending: Trending
  Vault: Vault
  WITHDRAW: WITHDRAW
  WITHDRWAWAL_HISTORY: WITHDRWAWAL HISTORY
  Withdraw: Withdraw
  WithdrawDetail: WITHDRAW DETAILS
  WithdrawalDetails: Withdrawal details
  WithdrawalHistory: Withdrawal history
  Withdrawalhistory: Withdrawal history
  messageBoard: Messages
  messageDetail: Messages
  messages: Messages
successful: Successful
videoGuide:
  CreatorsVideoGuide: Creation Tutorial
  FansVideoGuide: Fans' video guide
  WithdrawalTutorial: Withdrawal Tutorial
  title1: 'How to: Add telegram bot on dFans'
  title10: 'How to: Set up profile and subscription'
  title11: 'How to: swap USDT to ETH with metamask'
  title12: Top up ETH with Binance
  title13: How to top up with Coinbase Wallet
  title14: How to Top Up USDT
  title15: 'How to: exchange USDT to fiat currency - Kraken exchange'
  title16: How to Top Up ETH
  title17: Use BINANCE to convert USDT into RMB
  title18: How to become creator
  title19: 'dFans Launches FREE AI Chat Feature: Auto-Chat & PPV Sales for Creators'
  title2: 'How to: Set up tracking links on dFans'
  title3: 'How to: Deposit ETH with credit card or debit card on dFans'
  title4: 'How to: Send media in vault on dFans'
  title5: 'How to: Schedule post on dFans'
  title6: 'How to: Set up welcome message to new fans on dFans'
  title7: 'How to: Withdraw USDT from dFans'
  title8: 'How to: Offer your fans promotional discounts on dFans'
  title9: 'How to: Send PPV messages to all your fans at once on dFans'
  topDec1: >-
    We were thrilled to discover that {author} is also using dFans. Here's what
    she thinks of the dFans product...
  topDec2: >-
    We also welcome everyone to use dFans more and share your thoughts and
    suggestions. We'll continuously improve to make it the perfect platform for
    all creators.
videoPlayer:
  noSupport: |-
    To view this video please enable JavaScript, and consider upgrading to a
          web browser that supports HTML5 video
